import React, { useEffect, useRef, useState } from "react";
import {
  downloadFile,
  getAxiosResponse,
  deleteAxiosResponse,
  postAxiosFormDataResponse,
  postAxiosResponse,
} from "../../../services/authApiRoutes/APImethods";
import { confirmAlert } from "react-confirm-alert";
import UploadReferenceFile from "./UploadReferenceFile";
import UploadSourceFile from "./UploadSourceFile";
import UploadStyleGuide from "./UploadStyleGuide";
import { useSelector } from "react-redux";
import APIUrls from "../../../services/APIUrls";
import { Link, useParams, useNavigate } from "react-router-dom";
import { dateFormat } from "../../../services/Util";
import Constants from "../../../Constants";
import Tooltip from "react-tooltip";
import $ from "jquery";
import { handleError } from "../../../services/authApiRoutes/APImethods";
import { ConditionalBlock } from "../../../ConditionalBlock";
import DateFormat from "../../../pages/DateFormat";

export default function SourceFile(prop) {
  const masterDocTooltipRef = useRef(null);
  const sourceFileTooltipRef = useRef(null);
  const styleGuideTooltipRef = useRef(null);
  const [refs, setRefs] = useState({});
  const param = useParams();
  const [sourceAsset, setSourceAsset] = useState([]);
  const [sourceAssetFiles, setSourceAssetFiles] = useState([]);
  const [masterDocumentDetail, setMasterDocumentDetail] = useState([]);
  const [projectGlossary, setProjectGlossary] = useState([]);
  const [uiFeatures, setUiFeatures] = useState({});
  const [referenceMaterialId, setReferenceMaterialId] = useState(null);
  const projectResource = prop.projectDetail.resource.projectResource;
  const projectStatus = prop.projectDetail.displayName[0].status;
  const [sourceReferenceData, setSourceReferenceData] = useState([]);
  const [translationMemoryData, setTranslationMemoryData] = useState([]);
  const [styleGuideData, setStyleGuideData] = useState([]);
  const [fileUploadView, setFileUploadView] = useState(false);
  const [styleGuideUploadView, setStyleGuideUploadView] = useState(false);
  const [sourceFileUploadView, setSourceFileUploadView] = useState(false);
  const [invalidSourceFilesError, setInvalidSourceFilesError] = useState([]);
  const [options, setOptions] = useState({});
  const [delFocus, setDelFocus] = useState(false);
  const [uberTmList, setUberTmList] = useState([]);

  const navigate = useNavigate();
  const downloadSourceFile = (file_name) => {
    downloadFile(APIUrls.DOWNLOAD_SOURCE_MATERIAL(param.id), file_name);
  };
  const downloadAssetFile = (fileName, assetId) => {
    downloadFile(APIUrls.DOWNLOAD_ASSET_FILE(param.id, assetId), fileName);
  };
  const showFileUpload = (type, id) => {
    let isModelOpen;
    const activeElement = $(document.activeElement);
    $('.replaceProRefMaterial').not(activeElement).removeClass('focusClass').attr('aria-expanded', 'false');
    activeElement.toggleClass('focusClass');
    if (!(activeElement.attr('id') === 'addProRefMaterial')) {
      activeElement.attr('aria-expanded', function(index, attr) {
        return attr === 'true' ? 'false' : 'true';
      });
      $('#addProRefMaterial').attr('aria-expanded', 'false').removeClass('focusClass');
    }
    if ($('.focusClass').length) {
      setFileUploadView(true);
      isModelOpen = true;
    } else {
      setFileUploadView(false);
    }
    if ($('#uploadbtn').length) {
      if ($('#uploadbtn').hasClass('focusClass')) {
        $('#uploadbtn').attr('aria-expanded', 'true');
      } else {
        $('#uploadbtn').attr('aria-expanded', 'false');
      }
    } else if ($('#addProRefMaterial').length && activeElement.attr('id') === 'addProRefMaterial') {
      if ($('.upload-file-block').length && isModelOpen) {
        $('#addProRefMaterial').attr('aria-expanded', 'true');
        setFileUploadView(true);
        isModelOpen = false;
      } else {
        $('#addProRefMaterial').attr('aria-expanded', function(index, attr) {
          return attr === 'true' ? 'false' : 'true';
        });
        fileUploadView ? setFileUploadView(false) : setFileUploadView(true);
      }

    }

    if (id !== undefined) {
      setReferenceMaterialId(id);
    } else {
      setReferenceMaterialId(null);
    }
  };
  const showSourceFileUpload = () => {
    sourceFileUploadView
      ? setSourceFileUploadView(false)
      : setSourceFileUploadView(true);
  };
  const showStyleGuideUpload = () => {
    styleGuideUploadView
      ? setStyleGuideUploadView(false)
      : setStyleGuideUploadView(true);
  };
  const downloadGlossaryFile = (departId, file_name) => {
    downloadFile(APIUrls.GET_PROJECT_GLOSSARY_CONTENT(departId), null);
  };
  const downloadCompanyTm = (fileName) => {
    downloadFile(APIUrls.DOWNLAOD_SNAPSHOT_TM_COMPANY(param.id), fileName);
  };
  const downloadDepartmentTm = (fileName) => {
    downloadFile(
      APIUrls.DOWNLAOD_SNAPSHOT_TM_COMPANY(param.id) +
        `?depId=${prop.departmentId}`,
      fileName
    );
  };
  const downloadStyleGuide = (fileName) => {
    downloadFile(APIUrls.DOWNLOAD_STYLE_GUIDE, fileName);
  };
  const downloadResource = (fileName, docId) => {
    downloadFile(
      APIUrls.DOWNLOAD_REFERENCE_FILE_CONTENT(param.id, docId),
      fileName
    );
  };
  const relaunchBid = () => {
    postAxiosResponse(APIUrls.RELAUNCH_BID(param.id)).then((res) => {
      prop.refresh("sourceFile");
    }).catch(err=>{
      console.error(err)
    })
  };
  const confirmRelaunch = () => {
    setTimeout(() => {
      $("h1").attr({
        'id': 'bidRelaunch',
      });
      $("#react-confirm-alert").attr({
        'aria-labelledby':"bidRelaunch",
        'aria-modal': 'true',
        'role': 'dialog',
        });
      }, 200);
      setTimeout(() => {
        $("#cancelRelaunch").trigger("focus");
      }, 500);
    confirmAlert({
      title: "Request Quotes Again? ",
      message: (
        <p>{`If you are done updating your source, click OK to finish updating and request quotes again.`}</p>
      ),
      buttons: [
        {
          id: 'yesRelaunch',
          label: "Ok",
          onClick: () => {
            $('.lastdisable').trigger('focus');
            relaunchBid();
        },
          onKeyDown: (e) => {
            if (e.key===Constants.TAB) {
              e.preventDefault();
              $('#cancelRelaunch').trigger('focus');
            }
          }
        },
        {
          id: 'cancelRelaunch',
          label: "Cancel",
          onKeyDown: (e) => {
            if (e.key===Constants.TAB) {
              e.preventDefault();
              $('#yesRelaunch').trigger('focus');
            }
          }
        },
      ],
      closeOnEscape: true,
      closeOnClickOutside: true,
      overlayClassName: "delete_overlay",
      afterClose: () => {
        if ($(document.activeElement).hasClass('lastdisable')) {
          return;
        } else {
          $('#relaunchBid').trigger('focus');
        }
      }
    });
  };
  const confirmDelete = (project_id, asset_id) => {
    $(document.activeElement).addClass('deleteFocus');
    setTimeout(() => {
      $("h1").attr({
        'id': 'deleteProject',
      });
      $("#react-confirm-alert").attr({
        'aria-labelledby':"deleteProject",
        'aria-modal': 'true',
        'role': 'dialog',
        });
      }, 200);
      setTimeout(() => {
        $("#noToDel").trigger("focus");
      }, 500);

    confirmAlert({
      title: "Delete Reference Material",
      message: (
        <p>{`Click accept to delete this reference material. This can not be undone`}</p>
      ),
      buttons: [
        {
          id: "yesToDel",
          label: "Accept",
          onClick: () => {
            $('.lastdisable').trigger('focus');
            deleteAxiosResponse(
              APIUrls.REFERENCE_FILE(project_id, asset_id)
            ).then((res) => {
              getData();
              setDelFocus(true);
            }).catch(err=>{
              console.error(err)
            })
        }},
        {
          id: "noToDel",
          label: "No",
          onKeyDown: (e) => {
            if (e.key === Constants.TAB) {
              e.preventDefault();
              $("#yesToDel").trigger("focus");
            }
          },
        },
      ],
      closeOnEscape: true,
      closeOnClickOutside: true,
      overlayClassName: "delete_overlay",
      afterClose: () => {
        if ($(document.activeElement).hasClass('lastdisable')) {
          return;
        } else {
          $('.deleteFocus').trigger('focus');
          $('.deleteFocus').removeClass('deleteFocus');
        }
      }
    });
  };
  const custBootstrapDataRedux = useSelector(
    (store) => store.customer_bootstrap_data
  ).value;
  const confirmDeleteAsset = (assetId) => {
    confirmAlert({
      title: "Delete Source Material",
      message: (
        <p>{`Click accept to delete this project source material. This cannot be undone.`}</p>
      ),
      buttons: [
        {
          label: "Accept",
          onClick: () =>
            deleteAxiosResponse(APIUrls.ASSET(param.id, assetId)).then(
              (res) => {
                prop.refresh("sourceFile");
              }
            ).catch(err=>{
              console.error(err)
            }),
        },
        {
          label: "Cancel",
        },
      ],
      closeOnEscape: true,
      closeOnClickOutside: true,
      overlayClassName: "delete_overlay",
    })
  };
  const confirmDeleteStyleGuide = (styleGuideId) => {
    confirmAlert({
      title: "Delete style guide",
      message: (
        <p>{`Click accept to delete the style guide. This cannot be undone.`}</p>
      ),
      buttons: [
        {
          label: "Accept",
          onClick: () =>
            deleteAxiosResponse(APIUrls.ASSET(param.id, styleGuideId)).then(
              (res) => {
                prop.refresh("sourceFile");
              }
            ),
        },
        {
          label: "Cancel",
        },
      ],
      closeOnEscape: true,
      closeOnClickOutside: true,
      overlayClassName: "delete_overlay",
    }).catch(err=>{
      console.error(err)
    })
  };

  const formatBytes = (bytes, decimals = 2) => {
    if (!+bytes) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
  };
  const convertStringToList = (stringData) => {
    const array = stringData.split(",");
    return array;
  };
  const getSyncErrorsByType = (error) => {
    var errorArray = [];
    var projectSyncErrors = projectResource.syncErrors;
    if (projectSyncErrors && projectSyncErrors.length > 0) {
      for (var i = 0; i < projectSyncErrors.length; i++) {
        if (projectSyncErrors[i].errorType == error) {
          errorArray.push(projectSyncErrors[i]);
        }
      }
    }
    return errorArray;
  };
  const isAllowedToUpload = () => {
    return (
      custBootstrapDataRedux?.roleSet?.customerType &&
      custBootstrapDataRedux?.permissions?.PROJECT_CUD &&
      projectResource.userCanAlterProject &&
      !projectStatus.cancelled &&
      !projectStatus.closed
    );
  };
  const StyleGuideToolTip = () => {
    return (
      <React.Fragment>
        <button
          aria-label="tooltip"
          className="p-5 0"
          data-tip
          data-place="right"
          data-for="style-guide-content-0"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
          >
            <path
              d="M8 15C6.14348 15 4.36301 14.2625 3.05025 12.9497C1.7375 11.637 1 9.85652 1 8C1 6.14348 1.7375 4.36301 3.05025 3.05025C4.36301 1.7375 6.14348 1 8 1C9.85652 1 11.637 1.7375 12.9497 3.05025C14.2625 4.36301 15 6.14348 15 8C15 9.85652 14.2625 11.637 12.9497 12.9497C11.637 14.2625 9.85652 15 8 15ZM8 16C10.1217 16 12.1566 15.1571 13.6569 13.6569C15.1571 12.1566 16 10.1217 16 8C16 5.87827 15.1571 3.84344 13.6569 2.34315C12.1566 0.842855 10.1217 0 8 0C5.87827 0 3.84344 0.842855 2.34315 2.34315C0.842855 3.84344 0 5.87827 0 8C0 10.1217 0.842855 12.1566 2.34315 13.6569C3.84344 15.1571 5.87827 16 8 16Z"
              fill="#64748B"
            ></path>
            <path
              d="M8.92995 6.588L6.63995 6.875L6.55795 7.255L7.00795 7.338C7.30195 7.408 7.35995 7.514 7.29595 7.807L6.55795 11.275C6.36395 12.172 6.66295 12.594 7.36595 12.594C7.91095 12.594 8.54395 12.342 8.83095 11.996L8.91895 11.58C8.71895 11.756 8.42695 11.826 8.23295 11.826C7.95795 11.826 7.85795 11.633 7.92895 11.293L8.92995 6.588ZM8.99995 4.5C8.99995 4.76522 8.8946 5.01957 8.70706 5.20711C8.51952 5.39464 8.26517 5.5 7.99995 5.5C7.73474 5.5 7.48038 5.39464 7.29285 5.20711C7.10531 5.01957 6.99995 4.76522 6.99995 4.5C6.99995 4.23478 7.10531 3.98043 7.29285 3.79289C7.48038 3.60536 7.73474 3.5 7.99995 3.5C8.26517 3.5 8.51952 3.60536 8.70706 3.79289C8.8946 3.98043 8.99995 4.23478 8.99995 4.5Z"
              fill="#64748B"
            ></path>
          </svg>
        </button>
        {styleGuideData.fileContents &&
            styleGuideData.fileContents !== "" ? (
        <Tooltip
          className="extraClass"
          id="style-guide-content-0"
          delayHide={1000}
          effect="solid"
        >
          <div className="react-innerTooltip">
            
              <ul>
                <li>
                  <strong>Size</strong>
                </li>
                <li>{styleGuideData.sizeInKilobytes} KB</li>
                <li>
                  <strong>File Included in this zip</strong>
                </li>
                {convertStringToList(styleGuideData.fileContents).map(
                  (items, index) => {
                    return <li key={index}>{items}</li>;
                  }
                )}
              </ul>
            
          </div>
        </Tooltip>
        ) : (
          ""
        )}
      </React.Fragment>
    );
  };
  useEffect(() => {
    getAxiosResponse(APIUrls.FILTERED_PROJECT_UBER_TM(param.id)).then((res)=>{        
      let projectUberTmList = res.data.data.projectUberTmList;             
      setUberTmList(projectUberTmList);
    });   
    var targetErrors = getSyncErrorsByType("INVALID_SOURCE_FILE");
    setInvalidSourceFilesError(targetErrors);
    Tooltip.rebuild();
  }, []);

  $(".tooltipContainer").on("keydown", function (e) {
    if (e.key === Constants.ESCAPE) {
      if ($(this).attr("id") === "masterDocTooltip") {
        setRefs(masterDocTooltipRef);
      } else if ($(this).attr("id") === "sourceFileTooltip") {
        setRefs(sourceFileTooltipRef);
      }
    }
  });

  useEffect(() => {
    if (refs.current) {
      refs.current.hideTooltip();
      setRefs({});
    }
  }, [refs]);

  useEffect(() => {
    if (delFocus) {
      if (sourceReferenceData.length === 0) {
        $("#uploadbtn").trigger("focus");
        setDelFocus(false);
      } else if (sourceReferenceData.length > 0) {
        setTimeout(() => {
          $(".source-file .source-file-item.flex")
            .last()
            .find(".delete-file")
            .eq(1)
            .trigger("focus");
        }, 300);
        setDelFocus(false);
      }
    }
  }, [sourceReferenceData]);

  const getData = () => {
    setFileUploadView(false);
    setStyleGuideUploadView(false);
    setSourceFileUploadView(false);
    getAxiosResponse(APIUrls.GET_MASTER_DELIVERABLE_DOCUMENT_FILE(param.id))
      .then((res) => {
        if (res.data.data !== "") {
          setMasterDocumentDetail(res.data.data);
        }
      })
      .catch((err) => {
        handleError(err);
      });

    getAxiosResponse(APIUrls.GET_CUSTOMER_STYLE_GUIDE)
      .then((res) => {
        if (res.data !== "") {
          setStyleGuideData(res.data.data);
        }
      })
      .catch((err) => {
        handleError(err);
      });

    getAxiosResponse(APIUrls.REFERENCE_LIST(param.id))
      .then((res) => {
        if (res.data !== "") {
          setSourceReferenceData(res.data.data);
        }
      })
      .catch((err) => {
        handleError(err);
      });

    getAxiosResponse(APIUrls.GET_LATEST_PROJECT_SNAPSHOT(param.id))
      .then((res) => {
        if (res.data !== "") {
          setTranslationMemoryData(res.data.data);
        }
      })
      .catch((err) => {
        handleError(err);
      });

    getAxiosResponse(APIUrls.GET_SOURCE_ASSETS(param.id))
      .then((res) => {
        if (res.data !== "") {
          setSourceAsset(res.data.data.result);
        }
      })
      .catch((err) => {
        handleError(err);
      });

    getAxiosResponse(APIUrls.GET_LATEST_PROJECT_SOURCE_DOCUMENT(param.id))
      .then((res) => {
        if (res.data !== "") {
          setSourceAssetFiles(res.data.data);
        }
      })
      .catch((err) => {
        handleError(err);
      });

    getAxiosResponse(APIUrls.GET_PROJECT_GLOSSARY(param.id))
      .then((res) => {
        if (res.data !== "") {
          setProjectGlossary(res.data.data);
        }
      })
      .catch((err) => {
        handleError(err);
      });
  };
  useEffect(() => {
    getData();

    getAxiosResponse(APIUrls.GET_UI_FEATURES(param.id)).then((res) => {
      setUiFeatures(res.data.data);
    }).catch(err=>{
      console.error(err)
    })
    getAxiosResponse(APIUrls.CUSTOMER_BOOTSTRAP_DATA).then((res) => {
      setOptions(res.data.data);
    }).catch(err=>{
      console.error(err)
    })
    Tooltip.rebuild();
  }, []);

  const customTmDownload = (fileName, tm) => {      
    downloadFile(APIUrls.CUSTOM_TM_DOWNLOAD(tm?.id), fileName+"_CUSTOM_TM.zip")
  }

  return (
    <div className="listing-content">
      {projectResource.status.code === "waiting_for_source_update" &&
      invalidSourceFilesError &&
      invalidSourceFilesError.length > 0 ? (
        <div className="source-file invalid">
          <div
            className=""
            style={{
              border: "2px solid #FFADAD",
              padding: "8px",
              marginBottom: "15px",
            }}
          >
            <div>
              <p className="error">
                The following source files are invalid. Either delete the file
                or replace it with the corrected version.
              </p>
            </div>
            <div className="source-header flex-center">
              <div className="left flex">
                <h4>Failed File(s)</h4>
              </div>
              <div className="center">
                <h4>Reason</h4>
              </div>
              <div className="right"></div>
            </div>
            {invalidSourceFilesError.map((file, index) => {
              return (
                <div className="source-file-item " key={index}>
                  <div className="left flex">
                    <div className="icon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="22"
                        height="20"
                        viewBox="0 0 22 20"
                        fill="none"
                      >
                        <path
                          d="M7.31677 0.900024C7.66837 0.900024 8.01206 0.995054 8.31219 1.17323L8.48677 1.29002L10.5672 2.85002H18.1501C19.8015 2.85002 21.1651 4.08161 21.3727 5.67634L21.3932 5.88633L21.4001 6.10002V15.85C21.4001 17.5732 20.0591 18.983 18.3638 19.0931L18.1501 19.1H3.8501C2.12697 19.1 0.717046 17.7591 0.607014 16.0637L0.600098 15.85V4.15002C0.600098 2.4269 1.9411 1.01697 3.6364 0.906941L3.8501 0.900024H7.31677ZM16.2062 4.15002H14.9062V7.40002H16.2062V4.15002ZM13.6062 4.15002H10.5022L8.60502 6.14486C8.28298 6.48301 7.85199 6.69272 7.39175 6.73987L7.19296 6.75002L1.9001 6.74872V15.85C1.9001 16.8636 2.67345 17.6965 3.6623 17.7911L3.8501 17.8H14.9058L14.905 16.581C14.9018 16.5545 14.9001 16.5275 14.9001 16.5C14.9001 16.4729 14.9018 16.4461 14.905 16.4198L14.9043 15.2H14.2562C13.8971 15.2 13.6062 14.909 13.6062 14.55C13.6062 14.1911 13.8971 13.9 14.2562 13.9H14.9036L14.902 11.3H14.9001H14.2501C13.8912 11.3 13.6001 11.009 13.6001 10.65C13.6001 10.2911 13.8912 10 14.2501 10H14.9001L14.9006 8.70002H14.2562C14.0837 8.70002 13.9185 8.63154 13.7965 8.50964C13.6746 8.38775 13.6062 8.22242 13.6062 8.05002V4.15002ZM16.2046 15.85H16.8501C17.209 15.85 17.5001 16.1411 17.5001 16.5C17.5001 16.859 17.209 17.15 16.8501 17.15H16.2054L16.2058 17.8H18.1501C19.1637 17.8 19.9966 17.0267 20.0911 16.0379L20.1001 15.85V6.10002C20.1001 5.08641 19.3267 4.25344 18.3379 4.15896L18.1501 4.15002H17.5062V8.05002C17.5062 8.40901 17.2151 8.70002 16.8562 8.70002H16.2006L16.2024 11.95H16.8562C17.2151 11.95 17.5062 12.2411 17.5062 12.6C17.5062 12.959 17.2151 13.25 16.8562 13.25H16.2032L16.2039 14.4956C16.2054 14.5135 16.2062 14.5317 16.2062 14.55C16.2062 14.5681 16.2054 14.586 16.204 14.6037L16.2046 15.85ZM7.31677 2.20002H3.8501C2.83649 2.20002 2.00351 2.97338 1.90903 3.96223L1.9001 4.15002V5.44872L7.19296 5.45002C7.33527 5.45002 7.47261 5.40337 7.58466 5.31875L7.66365 5.2483L9.3023 3.52732L7.70677 2.33002C7.62239 2.26674 7.52431 2.22526 7.42121 2.20847L7.31677 2.20002Z"
                          fill="#128FEB"
                        />
                      </svg>
                    </div>
                    <div className="text">
                      <p>{file.asset.name}</p>
                    </div>
                  </div>
                  <div className="center" style={{ maxWidth: "65%" }}>
                    <p>{file.message}</p>
                  </div>
                  <div className="right"></div>
                </div>
              );
            })}
          </div>
          <div className="source-file">
            <div className="source-header flex-center">
              <div className="left flex">
                <h4>Source Materials</h4>
              </div>
              <div className="right">
                <Link id="relaunchBid" className="blue-btn" onClick={confirmRelaunch}>
                  Relaunch Quote
                </Link>
              </div>
            </div>

            {sourceAssetFiles.length > 0
              ? sourceAssetFiles.map((source, index) => {
                  return (
                    <div className="source-file-item 1" key={index}>
                      <div className="left flex">
                        <div className="icon">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="22"
                            height="20"
                            viewBox="0 0 22 20"
                            fill="none"
                          >
                            <path
                              d="M7.31677 0.900024C7.66837 0.900024 8.01206 0.995054 8.31219 1.17323L8.48677 1.29002L10.5672 2.85002H18.1501C19.8015 2.85002 21.1651 4.08161 21.3727 5.67634L21.3932 5.88633L21.4001 6.10002V15.85C21.4001 17.5732 20.0591 18.983 18.3638 19.0931L18.1501 19.1H3.8501C2.12697 19.1 0.717046 17.7591 0.607014 16.0637L0.600098 15.85V4.15002C0.600098 2.4269 1.9411 1.01697 3.6364 0.906941L3.8501 0.900024H7.31677ZM16.2062 4.15002H14.9062V7.40002H16.2062V4.15002ZM13.6062 4.15002H10.5022L8.60502 6.14486C8.28298 6.48301 7.85199 6.69272 7.39175 6.73987L7.19296 6.75002L1.9001 6.74872V15.85C1.9001 16.8636 2.67345 17.6965 3.6623 17.7911L3.8501 17.8H14.9058L14.905 16.581C14.9018 16.5545 14.9001 16.5275 14.9001 16.5C14.9001 16.4729 14.9018 16.4461 14.905 16.4198L14.9043 15.2H14.2562C13.8971 15.2 13.6062 14.909 13.6062 14.55C13.6062 14.1911 13.8971 13.9 14.2562 13.9H14.9036L14.902 11.3H14.9001H14.2501C13.8912 11.3 13.6001 11.009 13.6001 10.65C13.6001 10.2911 13.8912 10 14.2501 10H14.9001L14.9006 8.70002H14.2562C14.0837 8.70002 13.9185 8.63154 13.7965 8.50964C13.6746 8.38775 13.6062 8.22242 13.6062 8.05002V4.15002ZM16.2046 15.85H16.8501C17.209 15.85 17.5001 16.1411 17.5001 16.5C17.5001 16.859 17.209 17.15 16.8501 17.15H16.2054L16.2058 17.8H18.1501C19.1637 17.8 19.9966 17.0267 20.0911 16.0379L20.1001 15.85V6.10002C20.1001 5.08641 19.3267 4.25344 18.3379 4.15896L18.1501 4.15002H17.5062V8.05002C17.5062 8.40901 17.2151 8.70002 16.8562 8.70002H16.2006L16.2024 11.95H16.8562C17.2151 11.95 17.5062 12.2411 17.5062 12.6C17.5062 12.959 17.2151 13.25 16.8562 13.25H16.2032L16.2039 14.4956C16.2054 14.5135 16.2062 14.5317 16.2062 14.55C16.2062 14.5681 16.2054 14.586 16.204 14.6037L16.2046 15.85ZM7.31677 2.20002H3.8501C2.83649 2.20002 2.00351 2.97338 1.90903 3.96223L1.9001 4.15002V5.44872L7.19296 5.45002C7.33527 5.45002 7.47261 5.40337 7.58466 5.31875L7.66365 5.2483L9.3023 3.52732L7.70677 2.33002C7.62239 2.26674 7.52431 2.22526 7.42121 2.20847L7.31677 2.20002Z"
                              fill="#128FEB"
                            />
                          </svg>
                        </div>
                        <div className="text">
                          <p>{source.filename}</p>
                          <span>
                            <DateFormat date={source.createdDate} />
                          </span>
                        </div>
                      </div>
                      <div className="right">
                      {projectResource.status.code !== "extract_xliff_from_offline_files" ? 
                      <button
                      className="download-file 1"
                      onClick={() =>
                        downloadAssetFile(source.filename, source.id)
                      }
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="18"
                        viewBox="0 0 16 18"
                        fill="none"
                      >
                        <path
                          d="M8.00087 17.6527L15.0742 10.5794C15.1834 10.4518 15.2405 10.2878 15.234 10.12C15.2275 9.9522 15.158 9.79304 15.0392 9.67431C14.9205 9.55558 14.7614 9.48602 14.5936 9.47954C14.4258 9.47306 14.2617 9.53013 14.1342 9.63935L8.66753 15.0993V1.33268C8.66753 1.15587 8.5973 0.986302 8.47227 0.861278C8.34725 0.736254 8.17768 0.666016 8.00087 0.666016C7.82406 0.666016 7.65449 0.736254 7.52946 0.861278C7.40444 0.986302 7.3342 1.15587 7.3342 1.33268V15.0993L1.8742 9.63935C1.81444 9.56956 1.74089 9.51288 1.65818 9.47287C1.57547 9.43285 1.48538 9.41036 1.39357 9.40682C1.30176 9.40327 1.2102 9.41874 1.12465 9.45226C1.0391 9.48577 0.961404 9.53661 0.896434 9.60158C0.831464 9.66655 0.780626 9.74425 0.747109 9.8298C0.713593 9.91535 0.698122 10.0069 0.701669 10.0987C0.705215 10.1905 0.727702 10.2806 0.767717 10.3633C0.807733 10.446 0.864413 10.5196 0.934201 10.5794L8.00087 17.6527Z"
                          fill="#1D4ED8"
                        />
                      </svg>
                      Download
                    </button> : ''}
                        
                        {invalidSourceFilesError &&
                        invalidSourceFilesError.length > 0 ? (
                          <button
                            aria-label="delete-icon"
                            className="delete-icon"
                            onClick={() => confirmDeleteAsset(source.id)}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="17"
                              viewBox="0 0 16 17"
                              fill="none"
                            >
                              <path
                                d="M6.5 3H9.5C9.5 2.60218 9.34196 2.22064 9.06066 1.93934C8.77936 1.65804 8.39782 1.5 8 1.5C7.60218 1.5 7.22064 1.65804 6.93934 1.93934C6.65804 2.22064 6.5 2.60218 6.5 3ZM5.5 3C5.5 2.33696 5.76339 1.70107 6.23223 1.23223C6.70107 0.763392 7.33696 0.5 8 0.5C8.66304 0.5 9.29893 0.763392 9.76777 1.23223C10.2366 1.70107 10.5 2.33696 10.5 3H15.5C15.6326 3 15.7598 3.05268 15.8536 3.14645C15.9473 3.24021 16 3.36739 16 3.5C16 3.63261 15.9473 3.75979 15.8536 3.85355C15.7598 3.94732 15.6326 4 15.5 4H14.446L13.252 14.344C13.1676 15.0752 12.8173 15.7498 12.2679 16.2396C11.7184 16.7293 11.008 16.9999 10.272 17H5.728C4.99195 16.9999 4.28161 16.7293 3.73214 16.2396C3.18266 15.7498 2.8324 15.0752 2.748 14.344L1.554 4H0.5C0.367392 4 0.240215 3.94732 0.146447 3.85355C0.0526785 3.75979 0 3.63261 0 3.5C0 3.36739 0.0526785 3.24021 0.146447 3.14645C0.240215 3.05268 0.367392 3 0.5 3H5.5ZM3.741 14.23C3.79743 14.7174 4.03105 15.167 4.39742 15.4934C4.76379 15.8198 5.23735 16.0001 5.728 16H10.272C10.7627 16.0001 11.2362 15.8198 11.6026 15.4934C11.969 15.167 12.2026 14.7174 12.259 14.23L13.439 4H2.561L3.741 14.23ZM6.5 6.5C6.63261 6.5 6.75979 6.55268 6.85355 6.64645C6.94732 6.74021 7 6.86739 7 7V13C7 13.1326 6.94732 13.2598 6.85355 13.3536C6.75979 13.4473 6.63261 13.5 6.5 13.5C6.36739 13.5 6.24021 13.4473 6.14645 13.3536C6.05268 13.2598 6 13.1326 6 13V7C6 6.86739 6.05268 6.74021 6.14645 6.64645C6.24021 6.55268 6.36739 6.5 6.5 6.5ZM10 7C10 6.86739 9.94732 6.74021 9.85355 6.64645C9.75979 6.55268 9.63261 6.5 9.5 6.5C9.36739 6.5 9.24021 6.55268 9.14645 6.64645C9.05268 6.74021 9 6.86739 9 7V13C9 13.1326 9.05268 13.2598 9.14645 13.3536C9.24021 13.4473 9.36739 13.5 9.5 13.5C9.63261 13.5 9.75979 13.4473 9.85355 13.3536C9.94732 13.2598 10 13.1326 10 13V7Z"
                                fill="#1D4ED8"
                              />
                            </svg>
                          </button>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  );
                })
              : ""}
            {uiFeatures?.CHANGE_SOURCE_MATERIAL &&
            projectResource.useAssetWorkflow &&
            !(invalidSourceFilesError && invalidSourceFilesError.length > 0) ? (
              <div className="source-file-item flex justify-end">
                <button
                  className="delete-file"
                  onClick={() => showSourceFileUpload()}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="22"
                    height="22"
                    viewBox="0 0 22 22"
                    fill="none"
                  >
                    <path
                      d="M8.70833 3.05833C7.11299 3.05833 5.80833 4.36299 5.80833 5.95833V10.9417H4.275V5.95833C4.275 3.52034 6.27034 1.525 8.70833 1.525H13.2917C15.6795 1.525 17.6427 3.43903 17.7225 5.80833H16.1878C16.1091 4.28202 14.8367 3.05833 13.2917 3.05833H8.70833Z"
                      fill="#1D4ED8"
                      stroke="#F9FAFF"
                      strokeWidth="0.3"
                    ></path>
                    <path
                      d="M7.6722 10.2342L5.04173 13.6867L2.41126 10.2342H7.6722Z"
                      fill="#1D4ED8"
                      stroke="#F9FAFF"
                      strokeWidth="0.3"
                    ></path>
                    <path
                      d="M13.2917 18.9435C14.887 18.9435 16.1917 17.6388 16.1917 16.0435V10.6935H17.725V16.0435C17.725 18.4814 15.7297 20.4768 13.2917 20.4768H8.70833C6.32053 20.4768 4.35735 18.5628 4.27752 16.1935H5.81219C5.89089 17.7198 7.16329 18.9435 8.70833 18.9435H13.2917Z"
                      fill="#1D4ED8"
                      stroke="#F9FAFF"
                      strokeWidth="0.3"
                    ></path>
                    <path
                      d="M19.5887 11.7674H14.3278L16.9582 8.31489L19.5887 11.7674Z"
                      fill="#1D4ED8"
                      stroke="#F9FAFF"
                      strokeWidth="0.3"
                    ></path>
                  </svg>
                  Add another
                </button>
              </div>
            ) : (
              ""
            )}
            {sourceFileUploadView ? (
              <div className="p-5">
                <UploadSourceFile reference={param.id} funct={getData} />
              </div>
            ) : null}
          </div>

          <div className="source-file">
            {sourceReferenceData?.length !== 0 ? (
              <>
                <div className="source-header flex-center">
                  <h4>Project Reference Materials</h4>
                </div>
                {sourceReferenceData.map((reference, index) => {
                  return (
                    <React.Fragment key={index}>
                      <div className="source-file-item flex" key={index}>
                        <div className="left flex">
                          <div className="icon">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="22"
                              height="20"
                              viewBox="0 0 22 20"
                              fill="none"
                            >
                              <path
                                d="M7.31677 0.900024C7.66837 0.900024 8.01206 0.995054 8.31219 1.17323L8.48677 1.29002L10.5672 2.85002H18.1501C19.8015 2.85002 21.1651 4.08161 21.3727 5.67634L21.3932 5.88633L21.4001 6.10002V15.85C21.4001 17.5732 20.0591 18.983 18.3638 19.0931L18.1501 19.1H3.8501C2.12697 19.1 0.717046 17.7591 0.607014 16.0637L0.600098 15.85V4.15002C0.600098 2.4269 1.9411 1.01697 3.6364 0.906941L3.8501 0.900024H7.31677ZM16.2062 4.15002H14.9062V7.40002H16.2062V4.15002ZM13.6062 4.15002H10.5022L8.60502 6.14486C8.28298 6.48301 7.85199 6.69272 7.39175 6.73987L7.19296 6.75002L1.9001 6.74872V15.85C1.9001 16.8636 2.67345 17.6965 3.6623 17.7911L3.8501 17.8H14.9058L14.905 16.581C14.9018 16.5545 14.9001 16.5275 14.9001 16.5C14.9001 16.4729 14.9018 16.4461 14.905 16.4198L14.9043 15.2H14.2562C13.8971 15.2 13.6062 14.909 13.6062 14.55C13.6062 14.1911 13.8971 13.9 14.2562 13.9H14.9036L14.902 11.3H14.9001H14.2501C13.8912 11.3 13.6001 11.009 13.6001 10.65C13.6001 10.2911 13.8912 10 14.2501 10H14.9001L14.9006 8.70002H14.2562C14.0837 8.70002 13.9185 8.63154 13.7965 8.50964C13.6746 8.38775 13.6062 8.22242 13.6062 8.05002V4.15002ZM16.2046 15.85H16.8501C17.209 15.85 17.5001 16.1411 17.5001 16.5C17.5001 16.859 17.209 17.15 16.8501 17.15H16.2054L16.2058 17.8H18.1501C19.1637 17.8 19.9966 17.0267 20.0911 16.0379L20.1001 15.85V6.10002C20.1001 5.08641 19.3267 4.25344 18.3379 4.15896L18.1501 4.15002H17.5062V8.05002C17.5062 8.40901 17.2151 8.70002 16.8562 8.70002H16.2006L16.2024 11.95H16.8562C17.2151 11.95 17.5062 12.2411 17.5062 12.6C17.5062 12.959 17.2151 13.25 16.8562 13.25H16.2032L16.2039 14.4956C16.2054 14.5135 16.2062 14.5317 16.2062 14.55C16.2062 14.5681 16.2054 14.586 16.204 14.6037L16.2046 15.85ZM7.31677 2.20002H3.8501C2.83649 2.20002 2.00351 2.97338 1.90903 3.96223L1.9001 4.15002V5.44872L7.19296 5.45002C7.33527 5.45002 7.47261 5.40337 7.58466 5.31875L7.66365 5.2483L9.3023 3.52732L7.70677 2.33002C7.62239 2.26674 7.52431 2.22526 7.42121 2.20847L7.31677 2.20002Z"
                                fill="#128FEB"
                              />
                            </svg>
                          </div>
                          <div className="text">
                            <p>{reference.filename}</p>
                            <span>
                              <DateFormat date={reference.createdDate} />
                            </span>
                            <span>{reference.sizeInKilobytes} kb</span>
                          </div>
                        </div>
                        <div className="right">
                          <button
                            className="delete-file"
                            onClick={() =>
                              showFileUpload("replace", reference.id)
                            }
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="22"
                              height="22"
                              viewBox="0 0 22 22"
                              fill="none"
                            >
                              <path
                                d="M8.70833 3.05833C7.11299 3.05833 5.80833 4.36299 5.80833 5.95833V10.9417H4.275V5.95833C4.275 3.52034 6.27034 1.525 8.70833 1.525H13.2917C15.6795 1.525 17.6427 3.43903 17.7225 5.80833H16.1878C16.1091 4.28202 14.8367 3.05833 13.2917 3.05833H8.70833Z"
                                fill="#1D4ED8"
                                stroke="#F9FAFF"
                                strokeWidth="0.3"
                              />
                              <path
                                d="M7.6722 10.2342L5.04173 13.6867L2.41126 10.2342H7.6722Z"
                                fill="#1D4ED8"
                                stroke="#F9FAFF"
                                strokeWidth="0.3"
                              />
                              <path
                                d="M13.2917 18.9435C14.887 18.9435 16.1917 17.6388 16.1917 16.0435V10.6935H17.725V16.0435C17.725 18.4814 15.7297 20.4768 13.2917 20.4768H8.70833C6.32053 20.4768 4.35735 18.5628 4.27752 16.1935H5.81219C5.89089 17.7198 7.16329 18.9435 8.70833 18.9435H13.2917Z"
                                fill="#1D4ED8"
                                stroke="#F9FAFF"
                                strokeWidth="0.3"
                              />
                              <path
                                d="M19.5887 11.7674H14.3278L16.9582 8.31489L19.5887 11.7674Z"
                                fill="#1D4ED8"
                                stroke="#F9FAFF"
                                strokeWidth="0.3"
                              />
                            </svg>
                            Replace
                          </button>
                          <button
                            className="delete-file"
                            onClick={() =>
                              confirmDelete(param.id, reference.id)
                            }
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="21"
                              viewBox="0 0 20 21"
                              fill="none"
                            >
                              <path
                                d="M8.1999 3.80005H11.7999C11.7999 3.32266 11.6103 2.86482 11.2727 2.52726C10.9351 2.18969 10.4773 2.00005 9.9999 2.00005C9.52251 2.00005 9.06468 2.18969 8.72711 2.52726C8.38954 2.86482 8.1999 3.32266 8.1999 3.80005ZM6.9999 3.80005C6.9999 3.0044 7.31597 2.24134 7.87858 1.67873C8.44119 1.11612 9.20425 0.800049 9.9999 0.800049C10.7956 0.800049 11.5586 1.11612 12.1212 1.67873C12.6838 2.24134 12.9999 3.0044 12.9999 3.80005H18.9999C19.159 3.80005 19.3116 3.86326 19.4242 3.97578C19.5367 4.08831 19.5999 4.24092 19.5999 4.40005C19.5999 4.55918 19.5367 4.71179 19.4242 4.82431C19.3116 4.93683 19.159 5.00005 18.9999 5.00005H17.7351L16.3023 17.4128C16.201 18.2903 15.7807 19.0999 15.1213 19.6875C14.462 20.2752 13.6096 20.6 12.7263 20.6H7.2735C6.39025 20.6 5.53784 20.2752 4.87847 19.6875C4.2191 19.0999 3.79878 18.2903 3.6975 17.4128L2.2647 5.00005H0.999902C0.840772 5.00005 0.68816 4.93683 0.575638 4.82431C0.463117 4.71179 0.399902 4.55918 0.399902 4.40005C0.399902 4.24092 0.463117 4.08831 0.575638 3.97578C0.68816 3.86326 0.840772 3.80005 0.999902 3.80005H6.9999ZM4.8891 17.276C4.95681 17.8609 5.23716 18.4005 5.6768 18.7921C6.11645 19.1838 6.68472 19.4001 7.2735 19.4H12.7263C13.3151 19.4001 13.8834 19.1838 14.323 18.7921C14.7626 18.4005 15.043 17.8609 15.1107 17.276L16.5267 5.00005H3.4731L4.8891 17.276ZM8.1999 8.00005C8.35903 8.00005 8.51165 8.06326 8.62417 8.17578C8.73669 8.28831 8.7999 8.44092 8.7999 8.60005V15.8C8.7999 15.9592 8.73669 16.1118 8.62417 16.2243C8.51165 16.3368 8.35903 16.4 8.1999 16.4C8.04077 16.4 7.88816 16.3368 7.77564 16.2243C7.66312 16.1118 7.5999 15.9592 7.5999 15.8V8.60005C7.5999 8.44092 7.66312 8.28831 7.77564 8.17578C7.88816 8.06326 8.04077 8.00005 8.1999 8.00005ZM12.3999 8.60005C12.3999 8.44092 12.3367 8.28831 12.2242 8.17578C12.1116 8.06326 11.959 8.00005 11.7999 8.00005C11.6408 8.00005 11.4882 8.06326 11.3756 8.17578C11.2631 8.28831 11.1999 8.44092 11.1999 8.60005V15.8C11.1999 15.9592 11.2631 16.1118 11.3756 16.2243C11.4882 16.3368 11.6408 16.4 11.7999 16.4C11.959 16.4 12.1116 16.3368 12.2242 16.2243C12.3367 16.1118 12.3999 15.9592 12.3999 15.8V8.60005Z"
                                fill="#1D4ED8"
                              />
                            </svg>
                            Delete
                          </button>
                          <button
                            className="download-file"
                            onClick={() =>
                              downloadResource(reference.filename, reference.id)
                            }
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="18"
                              viewBox="0 0 16 18"
                              fill="none"
                            >
                              <path
                                d="M8.00087 17.6527L15.0742 10.5794C15.1834 10.4518 15.2405 10.2878 15.234 10.12C15.2275 9.9522 15.158 9.79304 15.0392 9.67431C14.9205 9.55558 14.7614 9.48602 14.5936 9.47954C14.4258 9.47306 14.2617 9.53013 14.1342 9.63935L8.66753 15.0993V1.33268C8.66753 1.15587 8.5973 0.986302 8.47227 0.861278C8.34725 0.736254 8.17768 0.666016 8.00087 0.666016C7.82406 0.666016 7.65449 0.736254 7.52946 0.861278C7.40444 0.986302 7.3342 1.15587 7.3342 1.33268V15.0993L1.8742 9.63935C1.81444 9.56956 1.74089 9.51288 1.65818 9.47287C1.57547 9.43285 1.48538 9.41036 1.39357 9.40682C1.30176 9.40327 1.2102 9.41874 1.12465 9.45226C1.0391 9.48577 0.961404 9.53661 0.896434 9.60158C0.831464 9.66655 0.780626 9.74425 0.747109 9.8298C0.713593 9.91535 0.698122 10.0069 0.701669 10.0987C0.705215 10.1905 0.727702 10.2806 0.767717 10.3633C0.807733 10.446 0.864413 10.5196 0.934201 10.5794L8.00087 17.6527Z"
                                fill="#1D4ED8"
                              />
                            </svg>
                            Download
                          </button>
                        </div>
                      </div>
                      <div className="source-file-item justify-end">
                        <div className="right">
                          {isAllowedToUpload() ? (
                            <button
                              className="delete-file"
                              onClick={() => showFileUpload("new")}
                            >
                              Add another
                            </button>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    </React.Fragment>
                  );
                })}{" "}
              </>
            ) : (
              <>
                <div className="source-header flex-center">
                  <h4>Project Reference Materials</h4>
                </div>
                <div className="source-file-item">
                  <div className="left flex">
                    <div className="text">
                      You haven't uploaded any reference materials. Once you
                      upload them, they will be displayed here.
                    </div>
                  </div>
                  <div className="right">
                    {isAllowedToUpload() ? (
                      <button onClick={() => showFileUpload("new")}>
                        Upload
                      </button>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </>
            )}
            {fileUploadView ? (
              <div className="p-5">
                <UploadReferenceFile
                  reference={param.id}
                  funct={getData}
                  refId={referenceMaterialId}
                  delFocus={setDelFocus}
                />
              </div>
            ) : null}
          </div>
          <div className="source-file">
            <div className="source-header flex-center">
              <h4>Glossary (Reference)</h4>
            </div>
            {projectGlossary?.length > 0 ? (
              projectGlossary.map((glossary, index) => {
                return (
                  <div className="source-file-item" key={index}>
                    <div className="left flex">
                      <div className="icon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="22"
                          height="20"
                          viewBox="0 0 22 20"
                          fill="none"
                        >
                          <path
                            d="M7.31677 0.900024C7.66837 0.900024 8.01206 0.995054 8.31219 1.17323L8.48677 1.29002L10.5672 2.85002H18.1501C19.8015 2.85002 21.1651 4.08161 21.3727 5.67634L21.3932 5.88633L21.4001 6.10002V15.85C21.4001 17.5732 20.0591 18.983 18.3638 19.0931L18.1501 19.1H3.8501C2.12697 19.1 0.717046 17.7591 0.607014 16.0637L0.600098 15.85V4.15002C0.600098 2.4269 1.9411 1.01697 3.6364 0.906941L3.8501 0.900024H7.31677ZM16.2062 4.15002H14.9062V7.40002H16.2062V4.15002ZM13.6062 4.15002H10.5022L8.60502 6.14486C8.28298 6.48301 7.85199 6.69272 7.39175 6.73987L7.19296 6.75002L1.9001 6.74872V15.85C1.9001 16.8636 2.67345 17.6965 3.6623 17.7911L3.8501 17.8H14.9058L14.905 16.581C14.9018 16.5545 14.9001 16.5275 14.9001 16.5C14.9001 16.4729 14.9018 16.4461 14.905 16.4198L14.9043 15.2H14.2562C13.8971 15.2 13.6062 14.909 13.6062 14.55C13.6062 14.1911 13.8971 13.9 14.2562 13.9H14.9036L14.902 11.3H14.9001H14.2501C13.8912 11.3 13.6001 11.009 13.6001 10.65C13.6001 10.2911 13.8912 10 14.2501 10H14.9001L14.9006 8.70002H14.2562C14.0837 8.70002 13.9185 8.63154 13.7965 8.50964C13.6746 8.38775 13.6062 8.22242 13.6062 8.05002V4.15002ZM16.2046 15.85H16.8501C17.209 15.85 17.5001 16.1411 17.5001 16.5C17.5001 16.859 17.209 17.15 16.8501 17.15H16.2054L16.2058 17.8H18.1501C19.1637 17.8 19.9966 17.0267 20.0911 16.0379L20.1001 15.85V6.10002C20.1001 5.08641 19.3267 4.25344 18.3379 4.15896L18.1501 4.15002H17.5062V8.05002C17.5062 8.40901 17.2151 8.70002 16.8562 8.70002H16.2006L16.2024 11.95H16.8562C17.2151 11.95 17.5062 12.2411 17.5062 12.6C17.5062 12.959 17.2151 13.25 16.8562 13.25H16.2032L16.2039 14.4956C16.2054 14.5135 16.2062 14.5317 16.2062 14.55C16.2062 14.5681 16.2054 14.586 16.204 14.6037L16.2046 15.85ZM7.31677 2.20002H3.8501C2.83649 2.20002 2.00351 2.97338 1.90903 3.96223L1.9001 4.15002V5.44872L7.19296 5.45002C7.33527 5.45002 7.47261 5.40337 7.58466 5.31875L7.66365 5.2483L9.3023 3.52732L7.70677 2.33002C7.62239 2.26674 7.52431 2.22526 7.42121 2.20847L7.31677 2.20002Z"
                            fill="#128FEB"
                          />
                        </svg>
                      </div>
                      <div className="text">
                        <p>
                          {glossary.generalGlossary
                            ? "Company Glossary"
                            : glossary.userGroup.name + " Glossary"}{" "}
                        </p>
                        <span>
                          {dateFormat(
                            glossary.lastModifiedDate,
                            Constants.DATE_FORMAT
                          )}
                        </span>
                        {/* <span>7.5 mb</span> */}
                      </div>
                    </div>
                    <div className="right">
                      <button
                        className="download-file"
                        onClick={
                          glossary.generalGlossary
                            ? () =>
                                downloadGlossaryFile(
                                  glossary.userGroup.id,
                                  glossary
                                )
                            : () =>
                                downloadGlossaryFile(
                                  glossary.userGroup.id,
                                  "department_glossary.zip"
                                )
                        }
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="18"
                          viewBox="0 0 16 18"
                          fill="none"
                        >
                          <path
                            d="M8.00087 17.6527L15.0742 10.5794C15.1834 10.4518 15.2405 10.2878 15.234 10.12C15.2275 9.9522 15.158 9.79304 15.0392 9.67431C14.9205 9.55558 14.7614 9.48602 14.5936 9.47954C14.4258 9.47306 14.2617 9.53013 14.1342 9.63935L8.66753 15.0993V1.33268C8.66753 1.15587 8.5973 0.986302 8.47227 0.861278C8.34725 0.736254 8.17768 0.666016 8.00087 0.666016C7.82406 0.666016 7.65449 0.736254 7.52946 0.861278C7.40444 0.986302 7.3342 1.15587 7.3342 1.33268V15.0993L1.8742 9.63935C1.81444 9.56956 1.74089 9.51288 1.65818 9.47287C1.57547 9.43285 1.48538 9.41036 1.39357 9.40682C1.30176 9.40327 1.2102 9.41874 1.12465 9.45226C1.0391 9.48577 0.961404 9.53661 0.896434 9.60158C0.831464 9.66655 0.780626 9.74425 0.747109 9.8298C0.713593 9.91535 0.698122 10.0069 0.701669 10.0987C0.705215 10.1905 0.727702 10.2806 0.767717 10.3633C0.807733 10.446 0.864413 10.5196 0.934201 10.5794L8.00087 17.6527Z"
                            fill="#1D4ED8"
                          />
                        </svg>
                        Download
                      </button>
                    </div>
                  </div>
                );
              })
            ) : (
              <div className="source-file-item">
                <div className="left flex">
                  <div className="text">
                    Improve translation quality by uploading a Glossary
                  </div>
                </div>
                <div className="right">
                  <button
                    className="upload-file"
                    onClick={() => navigate("/reference")}
                  >
                    Gloassary
                  </button>
                </div>
              </div>
            )}
          </div>
          {translationMemoryData?.length !== 0 ? (
            <div className="source-file">
              <div className="source-header flex-center">
                <h4>Translation Memory</h4>
              </div>
              {translationMemoryData.map((memoryData, index) => {
                return (
                  <div className="source-file-item" key={index}>
                    <div className="left flex">
                      <div className="icon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="22"
                          height="20"
                          viewBox="0 0 22 20"
                          fill="none"
                        >
                          <path
                            d="M7.31677 0.900024C7.66837 0.900024 8.01206 0.995054 8.31219 1.17323L8.48677 1.29002L10.5672 2.85002H18.1501C19.8015 2.85002 21.1651 4.08161 21.3727 5.67634L21.3932 5.88633L21.4001 6.10002V15.85C21.4001 17.5732 20.0591 18.983 18.3638 19.0931L18.1501 19.1H3.8501C2.12697 19.1 0.717046 17.7591 0.607014 16.0637L0.600098 15.85V4.15002C0.600098 2.4269 1.9411 1.01697 3.6364 0.906941L3.8501 0.900024H7.31677ZM16.2062 4.15002H14.9062V7.40002H16.2062V4.15002ZM13.6062 4.15002H10.5022L8.60502 6.14486C8.28298 6.48301 7.85199 6.69272 7.39175 6.73987L7.19296 6.75002L1.9001 6.74872V15.85C1.9001 16.8636 2.67345 17.6965 3.6623 17.7911L3.8501 17.8H14.9058L14.905 16.581C14.9018 16.5545 14.9001 16.5275 14.9001 16.5C14.9001 16.4729 14.9018 16.4461 14.905 16.4198L14.9043 15.2H14.2562C13.8971 15.2 13.6062 14.909 13.6062 14.55C13.6062 14.1911 13.8971 13.9 14.2562 13.9H14.9036L14.902 11.3H14.9001H14.2501C13.8912 11.3 13.6001 11.009 13.6001 10.65C13.6001 10.2911 13.8912 10 14.2501 10H14.9001L14.9006 8.70002H14.2562C14.0837 8.70002 13.9185 8.63154 13.7965 8.50964C13.6746 8.38775 13.6062 8.22242 13.6062 8.05002V4.15002ZM16.2046 15.85H16.8501C17.209 15.85 17.5001 16.1411 17.5001 16.5C17.5001 16.859 17.209 17.15 16.8501 17.15H16.2054L16.2058 17.8H18.1501C19.1637 17.8 19.9966 17.0267 20.0911 16.0379L20.1001 15.85V6.10002C20.1001 5.08641 19.3267 4.25344 18.3379 4.15896L18.1501 4.15002H17.5062V8.05002C17.5062 8.40901 17.2151 8.70002 16.8562 8.70002H16.2006L16.2024 11.95H16.8562C17.2151 11.95 17.5062 12.2411 17.5062 12.6C17.5062 12.959 17.2151 13.25 16.8562 13.25H16.2032L16.2039 14.4956C16.2054 14.5135 16.2062 14.5317 16.2062 14.55C16.2062 14.5681 16.2054 14.586 16.204 14.6037L16.2046 15.85ZM7.31677 2.20002H3.8501C2.83649 2.20002 2.00351 2.97338 1.90903 3.96223L1.9001 4.15002V5.44872L7.19296 5.45002C7.33527 5.45002 7.47261 5.40337 7.58466 5.31875L7.66365 5.2483L9.3023 3.52732L7.70677 2.33002C7.62239 2.26674 7.52431 2.22526 7.42121 2.20847L7.31677 2.20002Z"
                            fill="#128FEB"
                          />
                        </svg>
                      </div>
                      <div className="text">
                        {memoryData.docType === "PROJECT_TM_SNAPSHOT" ? (
                          <p>Relevant Company Translation Memory</p>
                        ) : memoryData.docType ===
                          "PROJECT_USER_GROUP_TM_SNAPSHOT" ? (
                          <p>Relevant Department Translation Memory</p>
                        ) : (
                          ""
                        )}

                        <span>
                          <DateFormat date={memoryData.createdDate} />
                        </span>
                        <span>{memoryData.sizeInKilobytes} kb</span>
                      </div>
                    </div>
                    <div className="right">
                      <button
                        className="download-file"
                        onClick={
                          memoryData.docType === "PROJECT_TM_SNAPSHOT"
                            ? () => downloadCompanyTm(memoryData.filename)
                            : () => downloadDepartmentTm(memoryData.filename)
                        }
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="18"
                          viewBox="0 0 16 18"
                          fill="none"
                        >
                          <path
                            d="M8.00087 17.6527L15.0742 10.5794C15.1834 10.4518 15.2405 10.2878 15.234 10.12C15.2275 9.9522 15.158 9.79304 15.0392 9.67431C14.9205 9.55558 14.7614 9.48602 14.5936 9.47954C14.4258 9.47306 14.2617 9.53013 14.1342 9.63935L8.66753 15.0993V1.33268C8.66753 1.15587 8.5973 0.986302 8.47227 0.861278C8.34725 0.736254 8.17768 0.666016 8.00087 0.666016C7.82406 0.666016 7.65449 0.736254 7.52946 0.861278C7.40444 0.986302 7.3342 1.15587 7.3342 1.33268V15.0993L1.8742 9.63935C1.81444 9.56956 1.74089 9.51288 1.65818 9.47287C1.57547 9.43285 1.48538 9.41036 1.39357 9.40682C1.30176 9.40327 1.2102 9.41874 1.12465 9.45226C1.0391 9.48577 0.961404 9.53661 0.896434 9.60158C0.831464 9.66655 0.780626 9.74425 0.747109 9.8298C0.713593 9.91535 0.698122 10.0069 0.701669 10.0987C0.705215 10.1905 0.727702 10.2806 0.767717 10.3633C0.807733 10.446 0.864413 10.5196 0.934201 10.5794L8.00087 17.6527Z"
                            fill="#1D4ED8"
                          />
                        </svg>
                        Download
                      </button>
                    </div>
                  </div>
                );
              })}
            </div>
          ) : null}

          <div className="source-file">
            <div className="source-header flex-center">
              <h4>Style Guide</h4>
            </div>
            {styleGuideData?.length && styleGuideData?.length !== 0 ? (
              <div className="source-file-item styleguide">
                <div className="left flex">
                  <div className="icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="22"
                      height="20"
                      viewBox="0 0 22 20"
                      fill="none"
                    >
                      <path
                        d="M7.31677 0.900024C7.66837 0.900024 8.01206 0.995054 8.31219 1.17323L8.48677 1.29002L10.5672 2.85002H18.1501C19.8015 2.85002 21.1651 4.08161 21.3727 5.67634L21.3932 5.88633L21.4001 6.10002V15.85C21.4001 17.5732 20.0591 18.983 18.3638 19.0931L18.1501 19.1H3.8501C2.12697 19.1 0.717046 17.7591 0.607014 16.0637L0.600098 15.85V4.15002C0.600098 2.4269 1.9411 1.01697 3.6364 0.906941L3.8501 0.900024H7.31677ZM16.2062 4.15002H14.9062V7.40002H16.2062V4.15002ZM13.6062 4.15002H10.5022L8.60502 6.14486C8.28298 6.48301 7.85199 6.69272 7.39175 6.73987L7.19296 6.75002L1.9001 6.74872V15.85C1.9001 16.8636 2.67345 17.6965 3.6623 17.7911L3.8501 17.8H14.9058L14.905 16.581C14.9018 16.5545 14.9001 16.5275 14.9001 16.5C14.9001 16.4729 14.9018 16.4461 14.905 16.4198L14.9043 15.2H14.2562C13.8971 15.2 13.6062 14.909 13.6062 14.55C13.6062 14.1911 13.8971 13.9 14.2562 13.9H14.9036L14.902 11.3H14.9001H14.2501C13.8912 11.3 13.6001 11.009 13.6001 10.65C13.6001 10.2911 13.8912 10 14.2501 10H14.9001L14.9006 8.70002H14.2562C14.0837 8.70002 13.9185 8.63154 13.7965 8.50964C13.6746 8.38775 13.6062 8.22242 13.6062 8.05002V4.15002ZM16.2046 15.85H16.8501C17.209 15.85 17.5001 16.1411 17.5001 16.5C17.5001 16.859 17.209 17.15 16.8501 17.15H16.2054L16.2058 17.8H18.1501C19.1637 17.8 19.9966 17.0267 20.0911 16.0379L20.1001 15.85V6.10002C20.1001 5.08641 19.3267 4.25344 18.3379 4.15896L18.1501 4.15002H17.5062V8.05002C17.5062 8.40901 17.2151 8.70002 16.8562 8.70002H16.2006L16.2024 11.95H16.8562C17.2151 11.95 17.5062 12.2411 17.5062 12.6C17.5062 12.959 17.2151 13.25 16.8562 13.25H16.2032L16.2039 14.4956C16.2054 14.5135 16.2062 14.5317 16.2062 14.55C16.2062 14.5681 16.2054 14.586 16.204 14.6037L16.2046 15.85ZM7.31677 2.20002H3.8501C2.83649 2.20002 2.00351 2.97338 1.90903 3.96223L1.9001 4.15002V5.44872L7.19296 5.45002C7.33527 5.45002 7.47261 5.40337 7.58466 5.31875L7.66365 5.2483L9.3023 3.52732L7.70677 2.33002C7.62239 2.26674 7.52431 2.22526 7.42121 2.20847L7.31677 2.20002Z"
                        fill="#128FEB"
                      />
                    </svg>
                  </div>
                  <div className="text">
                    <p>{styleGuideData.filename}</p>
                    <span>
                      <DateFormat date={styleGuideData.createdDate} />
                    </span>
                    <span>{styleGuideData.sizeInKilobytes} kb</span>
                  </div>
                  <StyleGuideToolTip />
                </div>
                <div className="right">
                  <button
                    className="download-file"
                    onClick={() => downloadStyleGuide(styleGuideData.filename)}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="18"
                      viewBox="0 0 16 18"
                      fill="none"
                    >
                      <path
                        d="M8.00087 17.6527L15.0742 10.5794C15.1834 10.4518 15.2405 10.2878 15.234 10.12C15.2275 9.9522 15.158 9.79304 15.0392 9.67431C14.9205 9.55558 14.7614 9.48602 14.5936 9.47954C14.4258 9.47306 14.2617 9.53013 14.1342 9.63935L8.66753 15.0993V1.33268C8.66753 1.15587 8.5973 0.986302 8.47227 0.861278C8.34725 0.736254 8.17768 0.666016 8.00087 0.666016C7.82406 0.666016 7.65449 0.736254 7.52946 0.861278C7.40444 0.986302 7.3342 1.15587 7.3342 1.33268V15.0993L1.8742 9.63935C1.81444 9.56956 1.74089 9.51288 1.65818 9.47287C1.57547 9.43285 1.48538 9.41036 1.39357 9.40682C1.30176 9.40327 1.2102 9.41874 1.12465 9.45226C1.0391 9.48577 0.961404 9.53661 0.896434 9.60158C0.831464 9.66655 0.780626 9.74425 0.747109 9.8298C0.713593 9.91535 0.698122 10.0069 0.701669 10.0987C0.705215 10.1905 0.727702 10.2806 0.767717 10.3633C0.807733 10.446 0.864413 10.5196 0.934201 10.5794L8.00087 17.6527Z"
                        fill="#1D4ED8"
                      />
                    </svg>
                    Download
                  </button>
                </div>
              </div>
            ) : (
              <div className="source-file-item">
                <div className="left flex">
                  <div className="text">
                    Improve translation quality by uploading a style Guide
                  </div>
                </div>
                <div className="right">
                  <button
                    className="upload-file"
                    onClick={() => navigate("/reference")}
                  >
                    Style Guide
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      ) : (
        <>
          {masterDocumentDetail?.id && sourceAssetFiles?.length !== 0 ? (
            <div className="source-file">
              <div className="source-header flex-center">
                <div className="left flex">
                  <h4>Source Materials</h4>
                </div>
                <div className="right">
                  {options?.roleSet?.value === "ROLE_CUSTOMER" &&
                  projectStatus?.code === "waiting_for_source_update" ? (
                    <Link className="blue-btn" onClick={confirmRelaunch}>
                      Relaunch Quote
                    </Link>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <div className="source-file-item 2">
                <div className="left flex">
                  <div className="icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="22"
                      height="20"
                      viewBox="0 0 22 20"
                      fill="none"
                    >
                      <path
                        d="M7.31677 0.900024C7.66837 0.900024 8.01206 0.995054 8.31219 1.17323L8.48677 1.29002L10.5672 2.85002H18.1501C19.8015 2.85002 21.1651 4.08161 21.3727 5.67634L21.3932 5.88633L21.4001 6.10002V15.85C21.4001 17.5732 20.0591 18.983 18.3638 19.0931L18.1501 19.1H3.8501C2.12697 19.1 0.717046 17.7591 0.607014 16.0637L0.600098 15.85V4.15002C0.600098 2.4269 1.9411 1.01697 3.6364 0.906941L3.8501 0.900024H7.31677ZM16.2062 4.15002H14.9062V7.40002H16.2062V4.15002ZM13.6062 4.15002H10.5022L8.60502 6.14486C8.28298 6.48301 7.85199 6.69272 7.39175 6.73987L7.19296 6.75002L1.9001 6.74872V15.85C1.9001 16.8636 2.67345 17.6965 3.6623 17.7911L3.8501 17.8H14.9058L14.905 16.581C14.9018 16.5545 14.9001 16.5275 14.9001 16.5C14.9001 16.4729 14.9018 16.4461 14.905 16.4198L14.9043 15.2H14.2562C13.8971 15.2 13.6062 14.909 13.6062 14.55C13.6062 14.1911 13.8971 13.9 14.2562 13.9H14.9036L14.902 11.3H14.9001H14.2501C13.8912 11.3 13.6001 11.009 13.6001 10.65C13.6001 10.2911 13.8912 10 14.2501 10H14.9001L14.9006 8.70002H14.2562C14.0837 8.70002 13.9185 8.63154 13.7965 8.50964C13.6746 8.38775 13.6062 8.22242 13.6062 8.05002V4.15002ZM16.2046 15.85H16.8501C17.209 15.85 17.5001 16.1411 17.5001 16.5C17.5001 16.859 17.209 17.15 16.8501 17.15H16.2054L16.2058 17.8H18.1501C19.1637 17.8 19.9966 17.0267 20.0911 16.0379L20.1001 15.85V6.10002C20.1001 5.08641 19.3267 4.25344 18.3379 4.15896L18.1501 4.15002H17.5062V8.05002C17.5062 8.40901 17.2151 8.70002 16.8562 8.70002H16.2006L16.2024 11.95H16.8562C17.2151 11.95 17.5062 12.2411 17.5062 12.6C17.5062 12.959 17.2151 13.25 16.8562 13.25H16.2032L16.2039 14.4956C16.2054 14.5135 16.2062 14.5317 16.2062 14.55C16.2062 14.5681 16.2054 14.586 16.204 14.6037L16.2046 15.85ZM7.31677 2.20002H3.8501C2.83649 2.20002 2.00351 2.97338 1.90903 3.96223L1.9001 4.15002V5.44872L7.19296 5.45002C7.33527 5.45002 7.47261 5.40337 7.58466 5.31875L7.66365 5.2483L9.3023 3.52732L7.70677 2.33002C7.62239 2.26674 7.52431 2.22526 7.42121 2.20847L7.31677 2.20002Z"
                        fill="#128FEB"
                      />
                    </svg>
                  </div>
                  <div className="text">
                    <p>{masterDocumentDetail.filename}</p>
                    <span>
                      <DateFormat date={masterDocumentDetail.createdDate} />
                    </span>
                  </div>
                  <button
                    id="masterDocTooltip"
                    aria-label="tooltip"
                    className="p-5 0 tooltipContainer sourceTooltipFocus"
                    data-tip
                    data-place="right"
                    data-for="source-file-content-0"
                  >
                    <svg
                      className="aaa-change-icon"
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                    >
                      <path
                        d="M8 15C6.14348 15 4.36301 14.2625 3.05025 12.9497C1.7375 11.637 1 9.85652 1 8C1 6.14348 1.7375 4.36301 3.05025 3.05025C4.36301 1.7375 6.14348 1 8 1C9.85652 1 11.637 1.7375 12.9497 3.05025C14.2625 4.36301 15 6.14348 15 8C15 9.85652 14.2625 11.637 12.9497 12.9497C11.637 14.2625 9.85652 15 8 15ZM8 16C10.1217 16 12.1566 15.1571 13.6569 13.6569C15.1571 12.1566 16 10.1217 16 8C16 5.87827 15.1571 3.84344 13.6569 2.34315C12.1566 0.842855 10.1217 0 8 0C5.87827 0 3.84344 0.842855 2.34315 2.34315C0.842855 3.84344 0 5.87827 0 8C0 10.1217 0.842855 12.1566 2.34315 13.6569C3.84344 15.1571 5.87827 16 8 16Z"
                        fill="#64748B"
                      ></path>
                      <path
                        d="M8.92995 6.588L6.63995 6.875L6.55795 7.255L7.00795 7.338C7.30195 7.408 7.35995 7.514 7.29595 7.807L6.55795 11.275C6.36395 12.172 6.66295 12.594 7.36595 12.594C7.91095 12.594 8.54395 12.342 8.83095 11.996L8.91895 11.58C8.71895 11.756 8.42695 11.826 8.23295 11.826C7.95795 11.826 7.85795 11.633 7.92895 11.293L8.92995 6.588ZM8.99995 4.5C8.99995 4.76522 8.8946 5.01957 8.70706 5.20711C8.51952 5.39464 8.26517 5.5 7.99995 5.5C7.73474 5.5 7.48038 5.39464 7.29285 5.20711C7.10531 5.01957 6.99995 4.76522 6.99995 4.5C6.99995 4.23478 7.10531 3.98043 7.29285 3.79289C7.48038 3.60536 7.73474 3.5 7.99995 3.5C8.26517 3.5 8.51952 3.60536 8.70706 3.79289C8.8946 3.98043 8.99995 4.23478 8.99995 4.5Z"
                        fill="#64748B"
                      ></path>
                    </svg>
                  </button>
                  <Tooltip
                    className="extraClass"
                    id="source-file-content-0"
                    delayHide={1000}
                    effect="solid"
                    ref={masterDocTooltipRef}
                  >
                    <div className="react-innerTooltip">
                      <ul>
                        <li>
                          <strong>Size</strong>
                        </li>
                        <li>{masterDocumentDetail.sizeInKilobytes} KB</li>
                        {masterDocumentDetail.fileContents.length > 0 ? (
                          <React.Fragment>
                            <li>
                              <strong>File Included in this zip</strong>
                            </li>
                            {convertStringToList(
                              masterDocumentDetail.fileContents
                            ).map((items, index) => {
                              return <li key={index}>{items}</li>;
                            })}
                          </React.Fragment>
                        ) : (
                          ""
                        )}
                      </ul>
                    </div>
                  </Tooltip>
                </div>
                <div className="right">
                  {projectResource.status.code ===
                  "waiting_for_source_update" ? (
                    <button
                      aria-label="delete-icon"
                      className="delete-icon"
                      onClick={() =>
                        confirmDeleteAsset(masterDocumentDetail.id)
                      }
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="17"
                        viewBox="0 0 16 17"
                        fill="none"
                      >
                        <path
                          d="M6.5 3H9.5C9.5 2.60218 9.34196 2.22064 9.06066 1.93934C8.77936 1.65804 8.39782 1.5 8 1.5C7.60218 1.5 7.22064 1.65804 6.93934 1.93934C6.65804 2.22064 6.5 2.60218 6.5 3ZM5.5 3C5.5 2.33696 5.76339 1.70107 6.23223 1.23223C6.70107 0.763392 7.33696 0.5 8 0.5C8.66304 0.5 9.29893 0.763392 9.76777 1.23223C10.2366 1.70107 10.5 2.33696 10.5 3H15.5C15.6326 3 15.7598 3.05268 15.8536 3.14645C15.9473 3.24021 16 3.36739 16 3.5C16 3.63261 15.9473 3.75979 15.8536 3.85355C15.7598 3.94732 15.6326 4 15.5 4H14.446L13.252 14.344C13.1676 15.0752 12.8173 15.7498 12.2679 16.2396C11.7184 16.7293 11.008 16.9999 10.272 17H5.728C4.99195 16.9999 4.28161 16.7293 3.73214 16.2396C3.18266 15.7498 2.8324 15.0752 2.748 14.344L1.554 4H0.5C0.367392 4 0.240215 3.94732 0.146447 3.85355C0.0526785 3.75979 0 3.63261 0 3.5C0 3.36739 0.0526785 3.24021 0.146447 3.14645C0.240215 3.05268 0.367392 3 0.5 3H5.5ZM3.741 14.23C3.79743 14.7174 4.03105 15.167 4.39742 15.4934C4.76379 15.8198 5.23735 16.0001 5.728 16H10.272C10.7627 16.0001 11.2362 15.8198 11.6026 15.4934C11.969 15.167 12.2026 14.7174 12.259 14.23L13.439 4H2.561L3.741 14.23ZM6.5 6.5C6.63261 6.5 6.75979 6.55268 6.85355 6.64645C6.94732 6.74021 7 6.86739 7 7V13C7 13.1326 6.94732 13.2598 6.85355 13.3536C6.75979 13.4473 6.63261 13.5 6.5 13.5C6.36739 13.5 6.24021 13.4473 6.14645 13.3536C6.05268 13.2598 6 13.1326 6 13V7C6 6.86739 6.05268 6.74021 6.14645 6.64645C6.24021 6.55268 6.36739 6.5 6.5 6.5ZM10 7C10 6.86739 9.94732 6.74021 9.85355 6.64645C9.75979 6.55268 9.63261 6.5 9.5 6.5C9.36739 6.5 9.24021 6.55268 9.14645 6.64645C9.05268 6.74021 9 6.86739 9 7V13C9 13.1326 9.05268 13.2598 9.14645 13.3536C9.24021 13.4473 9.36739 13.5 9.5 13.5C9.63261 13.5 9.75979 13.4473 9.85355 13.3536C9.94732 13.2598 10 13.1326 10 13V7Z"
                          fill="#1D4ED8"
                        />
                      </svg>
                      Delete
                    </button>
                  ) : (
                    ""
                  )}
                  {projectResource.status.code !== "extract_xliff_from_offline_files" ? 
                  <button
                    className="download-file"
                    onClick={() =>
                      downloadSourceFile(masterDocumentDetail.filename)
                    }
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="18"
                      viewBox="0 0 16 18"
                      fill="none"
                    >
                      <path
                        d="M8.00087 17.6527L15.0742 10.5794C15.1834 10.4518 15.2405 10.2878 15.234 10.12C15.2275 9.9522 15.158 9.79304 15.0392 9.67431C14.9205 9.55558 14.7614 9.48602 14.5936 9.47954C14.4258 9.47306 14.2617 9.53013 14.1342 9.63935L8.66753 15.0993V1.33268C8.66753 1.15587 8.5973 0.986302 8.47227 0.861278C8.34725 0.736254 8.17768 0.666016 8.00087 0.666016C7.82406 0.666016 7.65449 0.736254 7.52946 0.861278C7.40444 0.986302 7.3342 1.15587 7.3342 1.33268V15.0993L1.8742 9.63935C1.81444 9.56956 1.74089 9.51288 1.65818 9.47287C1.57547 9.43285 1.48538 9.41036 1.39357 9.40682C1.30176 9.40327 1.2102 9.41874 1.12465 9.45226C1.0391 9.48577 0.961404 9.53661 0.896434 9.60158C0.831464 9.66655 0.780626 9.74425 0.747109 9.8298C0.713593 9.91535 0.698122 10.0069 0.701669 10.0987C0.705215 10.1905 0.727702 10.2806 0.767717 10.3633C0.807733 10.446 0.864413 10.5196 0.934201 10.5794L8.00087 17.6527Z"
                        fill="#1D4ED8"
                      />
                    </svg>
                    Download
                  </button> : ''}
                </div> 
              </div>
              {uiFeatures.CHANGE_SOURCE_MATERIAL &&
              projectResource.useAssetWorkflow &&
              projectStatus?.code === "waiting_for_source_update" ? (
                <div className="source-file-item justify-end">
                  <div className="right">
                    <button
                      className="delete-file"
                      onClick={() => showSourceFileUpload()}
                    >
                      Add another
                    </button>
                  </div>
                </div>
              ) : (
                ""
              )}
              {prop.projectDetail.resource.allowedToCreateChangeOrder ? (
                projectResource.status.code !== "in_review" ? (
                  <div className="source-file-item justify-end">
                    <div className="right">
                      <Link onClick={() => prop.funct("changeOrder")}>
                        Add Source Material with Change Order
                      </Link>
                    </div>
                  </div>
                ) : (
                  ""
                )
              ) : (
                ""
              )}
              {sourceFileUploadView ? (
                <div className="p-5">
                  <UploadSourceFile reference={param.id} funct={getData} />
                </div>
              ) : null}
            </div>
          ) : (
            <div className="source-file">
              <div className="source-header flex-center">
                <div className="left flex">
                  <h4>Source Materials</h4>
                </div>
                <div className="right">
                  {options?.roleSet?.value === "ROLE_CUSTOMER" &&
                  projectStatus?.code === "waiting_for_source_update" ? (
                    <Link className="blue-btn" onClick={confirmRelaunch}>
                      Relaunch Quote
                    </Link>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              {sourceAssetFiles.length !== 0 ? (
                <>
                  {sourceAssetFiles.map((sourceFile) => {
                    return (
                      <div className="source-file-item 3">
                        <div className="left flex">
                          <div className="icon">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="22"
                              height="20"
                              viewBox="0 0 22 20"
                              fill="none"
                            >
                              <path
                                d="M7.31677 0.900024C7.66837 0.900024 8.01206 0.995054 8.31219 1.17323L8.48677 1.29002L10.5672 2.85002H18.1501C19.8015 2.85002 21.1651 4.08161 21.3727 5.67634L21.3932 5.88633L21.4001 6.10002V15.85C21.4001 17.5732 20.0591 18.983 18.3638 19.0931L18.1501 19.1H3.8501C2.12697 19.1 0.717046 17.7591 0.607014 16.0637L0.600098 15.85V4.15002C0.600098 2.4269 1.9411 1.01697 3.6364 0.906941L3.8501 0.900024H7.31677ZM16.2062 4.15002H14.9062V7.40002H16.2062V4.15002ZM13.6062 4.15002H10.5022L8.60502 6.14486C8.28298 6.48301 7.85199 6.69272 7.39175 6.73987L7.19296 6.75002L1.9001 6.74872V15.85C1.9001 16.8636 2.67345 17.6965 3.6623 17.7911L3.8501 17.8H14.9058L14.905 16.581C14.9018 16.5545 14.9001 16.5275 14.9001 16.5C14.9001 16.4729 14.9018 16.4461 14.905 16.4198L14.9043 15.2H14.2562C13.8971 15.2 13.6062 14.909 13.6062 14.55C13.6062 14.1911 13.8971 13.9 14.2562 13.9H14.9036L14.902 11.3H14.9001H14.2501C13.8912 11.3 13.6001 11.009 13.6001 10.65C13.6001 10.2911 13.8912 10 14.2501 10H14.9001L14.9006 8.70002H14.2562C14.0837 8.70002 13.9185 8.63154 13.7965 8.50964C13.6746 8.38775 13.6062 8.22242 13.6062 8.05002V4.15002ZM16.2046 15.85H16.8501C17.209 15.85 17.5001 16.1411 17.5001 16.5C17.5001 16.859 17.209 17.15 16.8501 17.15H16.2054L16.2058 17.8H18.1501C19.1637 17.8 19.9966 17.0267 20.0911 16.0379L20.1001 15.85V6.10002C20.1001 5.08641 19.3267 4.25344 18.3379 4.15896L18.1501 4.15002H17.5062V8.05002C17.5062 8.40901 17.2151 8.70002 16.8562 8.70002H16.2006L16.2024 11.95H16.8562C17.2151 11.95 17.5062 12.2411 17.5062 12.6C17.5062 12.959 17.2151 13.25 16.8562 13.25H16.2032L16.2039 14.4956C16.2054 14.5135 16.2062 14.5317 16.2062 14.55C16.2062 14.5681 16.2054 14.586 16.204 14.6037L16.2046 15.85ZM7.31677 2.20002H3.8501C2.83649 2.20002 2.00351 2.97338 1.90903 3.96223L1.9001 4.15002V5.44872L7.19296 5.45002C7.33527 5.45002 7.47261 5.40337 7.58466 5.31875L7.66365 5.2483L9.3023 3.52732L7.70677 2.33002C7.62239 2.26674 7.52431 2.22526 7.42121 2.20847L7.31677 2.20002Z"
                                fill="#128FEB"
                              />
                            </svg>
                          </div>
                          <div className="text">
                            <p>{sourceFile.filename}</p>
                            <span>
                              <DateFormat date={sourceFile.createdDate} />
                            </span>
                            {/* <span>7.5 mb</span> */}
                          </div>
                          {sourceFile.fileContents !== undefined &&
                          sourceFile.fileContents.length > 0 ? (
                            <React.Fragment>
                              <button
                                id="sourceFileTooltip"
                                aria-label="tooltip"
                                className="p-5"
                                data-tip
                                data-place="right"
                                data-for="source-file-content-1"
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="16"
                                  height="16"
                                  viewBox="0 0 16 16"
                                  fill="none"
                                >
                                  <path
                                    d="M8 15C6.14348 15 4.36301 14.2625 3.05025 12.9497C1.7375 11.637 1 9.85652 1 8C1 6.14348 1.7375 4.36301 3.05025 3.05025C4.36301 1.7375 6.14348 1 8 1C9.85652 1 11.637 1.7375 12.9497 3.05025C14.2625 4.36301 15 6.14348 15 8C15 9.85652 14.2625 11.637 12.9497 12.9497C11.637 14.2625 9.85652 15 8 15ZM8 16C10.1217 16 12.1566 15.1571 13.6569 13.6569C15.1571 12.1566 16 10.1217 16 8C16 5.87827 15.1571 3.84344 13.6569 2.34315C12.1566 0.842855 10.1217 0 8 0C5.87827 0 3.84344 0.842855 2.34315 2.34315C0.842855 3.84344 0 5.87827 0 8C0 10.1217 0.842855 12.1566 2.34315 13.6569C3.84344 15.1571 5.87827 16 8 16Z"
                                    fill="#64748B"
                                  ></path>
                                  <path
                                    d="M8.92995 6.588L6.63995 6.875L6.55795 7.255L7.00795 7.338C7.30195 7.408 7.35995 7.514 7.29595 7.807L6.55795 11.275C6.36395 12.172 6.66295 12.594 7.36595 12.594C7.91095 12.594 8.54395 12.342 8.83095 11.996L8.91895 11.58C8.71895 11.756 8.42695 11.826 8.23295 11.826C7.95795 11.826 7.85795 11.633 7.92895 11.293L8.92995 6.588ZM8.99995 4.5C8.99995 4.76522 8.8946 5.01957 8.70706 5.20711C8.51952 5.39464 8.26517 5.5 7.99995 5.5C7.73474 5.5 7.48038 5.39464 7.29285 5.20711C7.10531 5.01957 6.99995 4.76522 6.99995 4.5C6.99995 4.23478 7.10531 3.98043 7.29285 3.79289C7.48038 3.60536 7.73474 3.5 7.99995 3.5C8.26517 3.5 8.51952 3.60536 8.70706 3.79289C8.8946 3.98043 8.99995 4.23478 8.99995 4.5Z"
                                    fill="#64748B"
                                  ></path>
                                </svg>
                              </button>
                              <Tooltip
                                className="extraClass"
                                id="source-file-content-1"
                                delayHide={1000}
                                effect="solid"
                                ref={sourceFileTooltipRef}
                              >
                                <div className="react-innerTooltip">
                                  <ul>
                                    {convertStringToList(
                                      sourceFile.fileContents
                                    ).map((items, index) => {
                                      return <li key={index}>{items}</li>;
                                    })}
                                  </ul>
                                </div>
                              </Tooltip>
                            </React.Fragment>
                          ) : (
                            ""
                          )}
                        </div>
                        <div className="right">
                          {invalidSourceFilesError &&
                          invalidSourceFilesError.length > 0 ? (
                            <button
                              className="delete-file"
                              onClick={() => confirmDeleteAsset(sourceFile.id)}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="20"
                                height="21"
                                viewBox="0 0 20 21"
                                fill="none"
                              >
                                <path
                                  d="M8.1999 3.80005H11.7999C11.7999 3.32266 11.6103 2.86482 11.2727 2.52726C10.9351 2.18969 10.4773 2.00005 9.9999 2.00005C9.52251 2.00005 9.06468 2.18969 8.72711 2.52726C8.38954 2.86482 8.1999 3.32266 8.1999 3.80005ZM6.9999 3.80005C6.9999 3.0044 7.31597 2.24134 7.87858 1.67873C8.44119 1.11612 9.20425 0.800049 9.9999 0.800049C10.7956 0.800049 11.5586 1.11612 12.1212 1.67873C12.6838 2.24134 12.9999 3.0044 12.9999 3.80005H18.9999C19.159 3.80005 19.3116 3.86326 19.4242 3.97578C19.5367 4.08831 19.5999 4.24092 19.5999 4.40005C19.5999 4.55918 19.5367 4.71179 19.4242 4.82431C19.3116 4.93683 19.159 5.00005 18.9999 5.00005H17.7351L16.3023 17.4128C16.201 18.2903 15.7807 19.0999 15.1213 19.6875C14.462 20.2752 13.6096 20.6 12.7263 20.6H7.2735C6.39025 20.6 5.53784 20.2752 4.87847 19.6875C4.2191 19.0999 3.79878 18.2903 3.6975 17.4128L2.2647 5.00005H0.999902C0.840772 5.00005 0.68816 4.93683 0.575638 4.82431C0.463117 4.71179 0.399902 4.55918 0.399902 4.40005C0.399902 4.24092 0.463117 4.08831 0.575638 3.97578C0.68816 3.86326 0.840772 3.80005 0.999902 3.80005H6.9999ZM4.8891 17.276C4.95681 17.8609 5.23716 18.4005 5.6768 18.7921C6.11645 19.1838 6.68472 19.4001 7.2735 19.4H12.7263C13.3151 19.4001 13.8834 19.1838 14.323 18.7921C14.7626 18.4005 15.043 17.8609 15.1107 17.276L16.5267 5.00005H3.4731L4.8891 17.276ZM8.1999 8.00005C8.35903 8.00005 8.51165 8.06326 8.62417 8.17578C8.73669 8.28831 8.7999 8.44092 8.7999 8.60005V15.8C8.7999 15.9592 8.73669 16.1118 8.62417 16.2243C8.51165 16.3368 8.35903 16.4 8.1999 16.4C8.04077 16.4 7.88816 16.3368 7.77564 16.2243C7.66312 16.1118 7.5999 15.9592 7.5999 15.8V8.60005C7.5999 8.44092 7.66312 8.28831 7.77564 8.17578C7.88816 8.06326 8.04077 8.00005 8.1999 8.00005ZM12.3999 8.60005C12.3999 8.44092 12.3367 8.28831 12.2242 8.17578C12.1116 8.06326 11.959 8.00005 11.7999 8.00005C11.6408 8.00005 11.4882 8.06326 11.3756 8.17578C11.2631 8.28831 11.1999 8.44092 11.1999 8.60005V15.8C11.1999 15.9592 11.2631 16.1118 11.3756 16.2243C11.4882 16.3368 11.6408 16.4 11.7999 16.4C11.959 16.4 12.1116 16.3368 12.2242 16.2243C12.3367 16.1118 12.3999 15.9592 12.3999 15.8V8.60005Z"
                                  fill="#1D4ED8"
                                />
                              </svg>
                              Delete
                            </button>
                          ) : (
                            ""
                          )}
                           {projectResource.status.code !== "extract_xliff_from_offline_files" ?
                          <button
                            className="download-file"
                            onClick={() =>
                              downloadSourceFile(sourceFile.filename)
                            }
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="18"
                              viewBox="0 0 16 18"
                              fill="none"
                            >
                              <path
                                d="M8.00087 17.6527L15.0742 10.5794C15.1834 10.4518 15.2405 10.2878 15.234 10.12C15.2275 9.9522 15.158 9.79304 15.0392 9.67431C14.9205 9.55558 14.7614 9.48602 14.5936 9.47954C14.4258 9.47306 14.2617 9.53013 14.1342 9.63935L8.66753 15.0993V1.33268C8.66753 1.15587 8.5973 0.986302 8.47227 0.861278C8.34725 0.736254 8.17768 0.666016 8.00087 0.666016C7.82406 0.666016 7.65449 0.736254 7.52946 0.861278C7.40444 0.986302 7.3342 1.15587 7.3342 1.33268V15.0993L1.8742 9.63935C1.81444 9.56956 1.74089 9.51288 1.65818 9.47287C1.57547 9.43285 1.48538 9.41036 1.39357 9.40682C1.30176 9.40327 1.2102 9.41874 1.12465 9.45226C1.0391 9.48577 0.961404 9.53661 0.896434 9.60158C0.831464 9.66655 0.780626 9.74425 0.747109 9.8298C0.713593 9.91535 0.698122 10.0069 0.701669 10.0987C0.705215 10.1905 0.727702 10.2806 0.767717 10.3633C0.807733 10.446 0.864413 10.5196 0.934201 10.5794L8.00087 17.6527Z"
                                fill="#1D4ED8"
                              />
                            </svg>
                            Download
                          </button> : ""}
                        </div>
                      </div>
                    );
                  })}
                  <div className="source-file-item justify-end">
                    <div className="right">
                      {uiFeatures.CHANGE_SOURCE_MATERIAL &&
                      projectResource.useAssetWorkflow && projectStatus?.code !== "extract_xliff_from_offline_files"? (
                        <button
                          className="delete-file"
                          onClick={() => showSourceFileUpload()}
                        >
                          Add another
                        </button>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </>
              ) : projectStatus?.code === "waiting_for_source_update" ? (
                <div className="source-file-item 1">
                  <div className="left flex">
                    <div className="text">
                      Please upload your source materials. You can upload files
                      of any type.
                    </div>
                  </div>
                  <div className="right">
                    <button
                      className="download-file"
                      onClick={showSourceFileUpload}
                    >
                      Upload
                    </button>
                  </div>
                </div>
              ) : projectStatus?.code === "syncing_content_to_translate" || projectStatus?.code === "sync_content_to_translate" ? (
                <div className="source-file-item 1">
                  <div className="left flex">
                    <div className="text">
                      We are currently syncing your source materials for this
                      project.
                    </div>
                  </div>
                </div>
              ) : (
                <div className="source-file-item 1">
                  <div className="left flex">
                    <div className="text">
                      There are currently no source materials for this project.
                    </div>
                  </div>
                </div>
              )}
              {sourceFileUploadView ? (
                <div className="p-5">
                  <UploadSourceFile reference={param.id} funct={getData} />
                </div>
              ) : null}
            </div>
          )}

          <div className="source-file">
            {sourceReferenceData?.length !== 0 ? (
              <>
                <div className="source-header flex-center">
                  <h4>Project Reference Materials</h4>
                </div>
                {sourceReferenceData.map((reference, index) => {
                  return (
                    <div className="source-file-item flex" key={index}>
                      <div className="left flex">
                        <div className="icon">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="22"
                            height="20"
                            viewBox="0 0 22 20"
                            fill="none"
                          >
                            <path
                              d="M7.31677 0.900024C7.66837 0.900024 8.01206 0.995054 8.31219 1.17323L8.48677 1.29002L10.5672 2.85002H18.1501C19.8015 2.85002 21.1651 4.08161 21.3727 5.67634L21.3932 5.88633L21.4001 6.10002V15.85C21.4001 17.5732 20.0591 18.983 18.3638 19.0931L18.1501 19.1H3.8501C2.12697 19.1 0.717046 17.7591 0.607014 16.0637L0.600098 15.85V4.15002C0.600098 2.4269 1.9411 1.01697 3.6364 0.906941L3.8501 0.900024H7.31677ZM16.2062 4.15002H14.9062V7.40002H16.2062V4.15002ZM13.6062 4.15002H10.5022L8.60502 6.14486C8.28298 6.48301 7.85199 6.69272 7.39175 6.73987L7.19296 6.75002L1.9001 6.74872V15.85C1.9001 16.8636 2.67345 17.6965 3.6623 17.7911L3.8501 17.8H14.9058L14.905 16.581C14.9018 16.5545 14.9001 16.5275 14.9001 16.5C14.9001 16.4729 14.9018 16.4461 14.905 16.4198L14.9043 15.2H14.2562C13.8971 15.2 13.6062 14.909 13.6062 14.55C13.6062 14.1911 13.8971 13.9 14.2562 13.9H14.9036L14.902 11.3H14.9001H14.2501C13.8912 11.3 13.6001 11.009 13.6001 10.65C13.6001 10.2911 13.8912 10 14.2501 10H14.9001L14.9006 8.70002H14.2562C14.0837 8.70002 13.9185 8.63154 13.7965 8.50964C13.6746 8.38775 13.6062 8.22242 13.6062 8.05002V4.15002ZM16.2046 15.85H16.8501C17.209 15.85 17.5001 16.1411 17.5001 16.5C17.5001 16.859 17.209 17.15 16.8501 17.15H16.2054L16.2058 17.8H18.1501C19.1637 17.8 19.9966 17.0267 20.0911 16.0379L20.1001 15.85V6.10002C20.1001 5.08641 19.3267 4.25344 18.3379 4.15896L18.1501 4.15002H17.5062V8.05002C17.5062 8.40901 17.2151 8.70002 16.8562 8.70002H16.2006L16.2024 11.95H16.8562C17.2151 11.95 17.5062 12.2411 17.5062 12.6C17.5062 12.959 17.2151 13.25 16.8562 13.25H16.2032L16.2039 14.4956C16.2054 14.5135 16.2062 14.5317 16.2062 14.55C16.2062 14.5681 16.2054 14.586 16.204 14.6037L16.2046 15.85ZM7.31677 2.20002H3.8501C2.83649 2.20002 2.00351 2.97338 1.90903 3.96223L1.9001 4.15002V5.44872L7.19296 5.45002C7.33527 5.45002 7.47261 5.40337 7.58466 5.31875L7.66365 5.2483L9.3023 3.52732L7.70677 2.33002C7.62239 2.26674 7.52431 2.22526 7.42121 2.20847L7.31677 2.20002Z"
                              fill="#128FEB"
                            />
                          </svg>
                        </div>
                        <div className="text">
                          <p>{reference.filename}</p>
                          <span>
                            <DateFormat date={reference.createdDate} />
                          </span>
                          <span>{reference.sizeInKilobytes} kb</span>
                        </div>
                      </div>
                      <div className="right">
                        <button
                          className="delete-file replaceProRefMaterial"
                          onClick={() =>
                            showFileUpload("replace", reference.id)
                          }
                          aria-expanded="false"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="22"
                            height="22"
                            viewBox="0 0 22 22"
                            fill="none"
                          >
                            <path
                              d="M8.70833 3.05833C7.11299 3.05833 5.80833 4.36299 5.80833 5.95833V10.9417H4.275V5.95833C4.275 3.52034 6.27034 1.525 8.70833 1.525H13.2917C15.6795 1.525 17.6427 3.43903 17.7225 5.80833H16.1878C16.1091 4.28202 14.8367 3.05833 13.2917 3.05833H8.70833Z"
                              fill="#1D4ED8"
                              stroke="#F9FAFF"
                              strokeWidth="0.3"
                            />
                            <path
                              d="M7.6722 10.2342L5.04173 13.6867L2.41126 10.2342H7.6722Z"
                              fill="#1D4ED8"
                              stroke="#F9FAFF"
                              strokeWidth="0.3"
                            />
                            <path
                              d="M13.2917 18.9435C14.887 18.9435 16.1917 17.6388 16.1917 16.0435V10.6935H17.725V16.0435C17.725 18.4814 15.7297 20.4768 13.2917 20.4768H8.70833C6.32053 20.4768 4.35735 18.5628 4.27752 16.1935H5.81219C5.89089 17.7198 7.16329 18.9435 8.70833 18.9435H13.2917Z"
                              fill="#1D4ED8"
                              stroke="#F9FAFF"
                              strokeWidth="0.3"
                            />
                            <path
                              d="M19.5887 11.7674H14.3278L16.9582 8.31489L19.5887 11.7674Z"
                              fill="#1D4ED8"
                              stroke="#F9FAFF"
                              strokeWidth="0.3"
                            />
                          </svg>
                          Replace
                        </button>
                        <button
                          className="delete-file"
                          onClick={() => confirmDelete(param.id, reference.id)}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="21"
                            viewBox="0 0 20 21"
                            fill="none"
                          >
                            <path
                              d="M8.1999 3.80005H11.7999C11.7999 3.32266 11.6103 2.86482 11.2727 2.52726C10.9351 2.18969 10.4773 2.00005 9.9999 2.00005C9.52251 2.00005 9.06468 2.18969 8.72711 2.52726C8.38954 2.86482 8.1999 3.32266 8.1999 3.80005ZM6.9999 3.80005C6.9999 3.0044 7.31597 2.24134 7.87858 1.67873C8.44119 1.11612 9.20425 0.800049 9.9999 0.800049C10.7956 0.800049 11.5586 1.11612 12.1212 1.67873C12.6838 2.24134 12.9999 3.0044 12.9999 3.80005H18.9999C19.159 3.80005 19.3116 3.86326 19.4242 3.97578C19.5367 4.08831 19.5999 4.24092 19.5999 4.40005C19.5999 4.55918 19.5367 4.71179 19.4242 4.82431C19.3116 4.93683 19.159 5.00005 18.9999 5.00005H17.7351L16.3023 17.4128C16.201 18.2903 15.7807 19.0999 15.1213 19.6875C14.462 20.2752 13.6096 20.6 12.7263 20.6H7.2735C6.39025 20.6 5.53784 20.2752 4.87847 19.6875C4.2191 19.0999 3.79878 18.2903 3.6975 17.4128L2.2647 5.00005H0.999902C0.840772 5.00005 0.68816 4.93683 0.575638 4.82431C0.463117 4.71179 0.399902 4.55918 0.399902 4.40005C0.399902 4.24092 0.463117 4.08831 0.575638 3.97578C0.68816 3.86326 0.840772 3.80005 0.999902 3.80005H6.9999ZM4.8891 17.276C4.95681 17.8609 5.23716 18.4005 5.6768 18.7921C6.11645 19.1838 6.68472 19.4001 7.2735 19.4H12.7263C13.3151 19.4001 13.8834 19.1838 14.323 18.7921C14.7626 18.4005 15.043 17.8609 15.1107 17.276L16.5267 5.00005H3.4731L4.8891 17.276ZM8.1999 8.00005C8.35903 8.00005 8.51165 8.06326 8.62417 8.17578C8.73669 8.28831 8.7999 8.44092 8.7999 8.60005V15.8C8.7999 15.9592 8.73669 16.1118 8.62417 16.2243C8.51165 16.3368 8.35903 16.4 8.1999 16.4C8.04077 16.4 7.88816 16.3368 7.77564 16.2243C7.66312 16.1118 7.5999 15.9592 7.5999 15.8V8.60005C7.5999 8.44092 7.66312 8.28831 7.77564 8.17578C7.88816 8.06326 8.04077 8.00005 8.1999 8.00005ZM12.3999 8.60005C12.3999 8.44092 12.3367 8.28831 12.2242 8.17578C12.1116 8.06326 11.959 8.00005 11.7999 8.00005C11.6408 8.00005 11.4882 8.06326 11.3756 8.17578C11.2631 8.28831 11.1999 8.44092 11.1999 8.60005V15.8C11.1999 15.9592 11.2631 16.1118 11.3756 16.2243C11.4882 16.3368 11.6408 16.4 11.7999 16.4C11.959 16.4 12.1116 16.3368 12.2242 16.2243C12.3367 16.1118 12.3999 15.9592 12.3999 15.8V8.60005Z"
                              fill="#1D4ED8"
                            />
                          </svg>
                          Delete
                        </button>
                        <button
                          className="download-file"
                          onClick={() =>
                            downloadResource(reference.filename, reference.id)
                          }
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="18"
                            viewBox="0 0 16 18"
                            fill="none"
                          >
                            <path
                              d="M8.00087 17.6527L15.0742 10.5794C15.1834 10.4518 15.2405 10.2878 15.234 10.12C15.2275 9.9522 15.158 9.79304 15.0392 9.67431C14.9205 9.55558 14.7614 9.48602 14.5936 9.47954C14.4258 9.47306 14.2617 9.53013 14.1342 9.63935L8.66753 15.0993V1.33268C8.66753 1.15587 8.5973 0.986302 8.47227 0.861278C8.34725 0.736254 8.17768 0.666016 8.00087 0.666016C7.82406 0.666016 7.65449 0.736254 7.52946 0.861278C7.40444 0.986302 7.3342 1.15587 7.3342 1.33268V15.0993L1.8742 9.63935C1.81444 9.56956 1.74089 9.51288 1.65818 9.47287C1.57547 9.43285 1.48538 9.41036 1.39357 9.40682C1.30176 9.40327 1.2102 9.41874 1.12465 9.45226C1.0391 9.48577 0.961404 9.53661 0.896434 9.60158C0.831464 9.66655 0.780626 9.74425 0.747109 9.8298C0.713593 9.91535 0.698122 10.0069 0.701669 10.0987C0.705215 10.1905 0.727702 10.2806 0.767717 10.3633C0.807733 10.446 0.864413 10.5196 0.934201 10.5794L8.00087 17.6527Z"
                              fill="#1D4ED8"
                            />
                          </svg>
                          Download
                        </button>
                      </div>
                    </div>
                  );
                })}{" "}
                <div className="source-file-item justify-end">
                  <div className="right">
                    <button
                      id="addProRefMaterial"
                      className="add-file"
                      aria-expanded="false"
                      onClick={() => showFileUpload("new")}
                    >
                      Add another
                    </button>
                  </div>
                </div>
              </>
            ) : (
              <>
                <div className="source-header flex-center">
                  <h4>Project Reference Materials</h4>
                </div>
                <div className="source-file-item">
                  <div className="left flex">
                    <div className="text">
                      You haven't uploaded any reference materials. Once you
                      upload them, they will be displayed here.
                    </div>
                  </div>
                  <div className="right">
                    {isAllowedToUpload() ? (
                      <button
                        id="uploadbtn"
                        onClick={() => showFileUpload("new")}
                        aria-expanded="false"
                      >
                        Upload
                      </button>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </>
            )}
            {fileUploadView ? (
              <div className="p-5">
                <UploadReferenceFile
                  reference={param.id}
                  funct={getData}
                  refId={referenceMaterialId}
                  delFocus={setDelFocus}
                />
              </div>
            ) : null}
          </div>          
          <div className="source-file">
            <div className="source-header flex-center">
              <h4>Glossary (Reference)</h4>
            </div>
            {projectGlossary?.length > 0 ? (
              projectGlossary.map((glossary, index) => {
                return (
                  <div className="source-file-item" key={index}>
                    <div className="left flex">
                      <div className="icon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="22"
                          height="20"
                          viewBox="0 0 22 20"
                          fill="none"
                        >
                          <path
                            d="M7.31677 0.900024C7.66837 0.900024 8.01206 0.995054 8.31219 1.17323L8.48677 1.29002L10.5672 2.85002H18.1501C19.8015 2.85002 21.1651 4.08161 21.3727 5.67634L21.3932 5.88633L21.4001 6.10002V15.85C21.4001 17.5732 20.0591 18.983 18.3638 19.0931L18.1501 19.1H3.8501C2.12697 19.1 0.717046 17.7591 0.607014 16.0637L0.600098 15.85V4.15002C0.600098 2.4269 1.9411 1.01697 3.6364 0.906941L3.8501 0.900024H7.31677ZM16.2062 4.15002H14.9062V7.40002H16.2062V4.15002ZM13.6062 4.15002H10.5022L8.60502 6.14486C8.28298 6.48301 7.85199 6.69272 7.39175 6.73987L7.19296 6.75002L1.9001 6.74872V15.85C1.9001 16.8636 2.67345 17.6965 3.6623 17.7911L3.8501 17.8H14.9058L14.905 16.581C14.9018 16.5545 14.9001 16.5275 14.9001 16.5C14.9001 16.4729 14.9018 16.4461 14.905 16.4198L14.9043 15.2H14.2562C13.8971 15.2 13.6062 14.909 13.6062 14.55C13.6062 14.1911 13.8971 13.9 14.2562 13.9H14.9036L14.902 11.3H14.9001H14.2501C13.8912 11.3 13.6001 11.009 13.6001 10.65C13.6001 10.2911 13.8912 10 14.2501 10H14.9001L14.9006 8.70002H14.2562C14.0837 8.70002 13.9185 8.63154 13.7965 8.50964C13.6746 8.38775 13.6062 8.22242 13.6062 8.05002V4.15002ZM16.2046 15.85H16.8501C17.209 15.85 17.5001 16.1411 17.5001 16.5C17.5001 16.859 17.209 17.15 16.8501 17.15H16.2054L16.2058 17.8H18.1501C19.1637 17.8 19.9966 17.0267 20.0911 16.0379L20.1001 15.85V6.10002C20.1001 5.08641 19.3267 4.25344 18.3379 4.15896L18.1501 4.15002H17.5062V8.05002C17.5062 8.40901 17.2151 8.70002 16.8562 8.70002H16.2006L16.2024 11.95H16.8562C17.2151 11.95 17.5062 12.2411 17.5062 12.6C17.5062 12.959 17.2151 13.25 16.8562 13.25H16.2032L16.2039 14.4956C16.2054 14.5135 16.2062 14.5317 16.2062 14.55C16.2062 14.5681 16.2054 14.586 16.204 14.6037L16.2046 15.85ZM7.31677 2.20002H3.8501C2.83649 2.20002 2.00351 2.97338 1.90903 3.96223L1.9001 4.15002V5.44872L7.19296 5.45002C7.33527 5.45002 7.47261 5.40337 7.58466 5.31875L7.66365 5.2483L9.3023 3.52732L7.70677 2.33002C7.62239 2.26674 7.52431 2.22526 7.42121 2.20847L7.31677 2.20002Z"
                            fill="#128FEB"
                          />
                        </svg>
                      </div>
                      <div className="text">
                        <p>
                          {glossary.generalGlossary
                            ? "Company Glossary"
                            : glossary.userGroup.name + " Glossary"}{" "}
                        </p>
                        <span>
                          <DateFormat date={glossary.lastModifiedDate} />
                        </span>
                        {/* <span>7.5 mb</span> */}
                      </div>
                    </div>
                    <div className="right">
                      <button
                        className="download-file"
                        onClick={
                          glossary.generalGlossary
                            ? () =>
                                downloadGlossaryFile(
                                  glossary.userGroup.id,
                                  glossary
                                )
                            : () =>
                                downloadGlossaryFile(
                                  glossary.userGroup.id,
                                  glossary
                                )
                        }
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="18"
                          viewBox="0 0 16 18"
                          fill="none"
                        >
                          <path
                            d="M8.00087 17.6527L15.0742 10.5794C15.1834 10.4518 15.2405 10.2878 15.234 10.12C15.2275 9.9522 15.158 9.79304 15.0392 9.67431C14.9205 9.55558 14.7614 9.48602 14.5936 9.47954C14.4258 9.47306 14.2617 9.53013 14.1342 9.63935L8.66753 15.0993V1.33268C8.66753 1.15587 8.5973 0.986302 8.47227 0.861278C8.34725 0.736254 8.17768 0.666016 8.00087 0.666016C7.82406 0.666016 7.65449 0.736254 7.52946 0.861278C7.40444 0.986302 7.3342 1.15587 7.3342 1.33268V15.0993L1.8742 9.63935C1.81444 9.56956 1.74089 9.51288 1.65818 9.47287C1.57547 9.43285 1.48538 9.41036 1.39357 9.40682C1.30176 9.40327 1.2102 9.41874 1.12465 9.45226C1.0391 9.48577 0.961404 9.53661 0.896434 9.60158C0.831464 9.66655 0.780626 9.74425 0.747109 9.8298C0.713593 9.91535 0.698122 10.0069 0.701669 10.0987C0.705215 10.1905 0.727702 10.2806 0.767717 10.3633C0.807733 10.446 0.864413 10.5196 0.934201 10.5794L8.00087 17.6527Z"
                            fill="#1D4ED8"
                          />
                        </svg>
                        Download
                      </button>
                    </div>
                  </div>
                );
              })
            ) : (
              <div className="source-file-item">
                <div className="left flex">
                  <div className="text">
                    Improve translation quality by uploading a Glossary
                  </div>
                </div>
                <div className="right">
                  <button
                    className="upload-file"
                    onClick={() => navigate("/reference")}
                  >
                    Glossary
                  </button>
                </div>
              </div>
            )}
          </div>
          {translationMemoryData?.length !== 0 ? (
            <div className="source-file">
              <div className="source-header flex-center">
                <h4>Translation Memory</h4>
              </div>
              {translationMemoryData.map((memoryData, index) => {
                return (
                  <div className="source-file-item" key={index}>
                    <div className="left flex">
                      <div className="icon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="22"
                          height="20"
                          viewBox="0 0 22 20"
                          fill="none"
                        >
                          <path
                            d="M7.31677 0.900024C7.66837 0.900024 8.01206 0.995054 8.31219 1.17323L8.48677 1.29002L10.5672 2.85002H18.1501C19.8015 2.85002 21.1651 4.08161 21.3727 5.67634L21.3932 5.88633L21.4001 6.10002V15.85C21.4001 17.5732 20.0591 18.983 18.3638 19.0931L18.1501 19.1H3.8501C2.12697 19.1 0.717046 17.7591 0.607014 16.0637L0.600098 15.85V4.15002C0.600098 2.4269 1.9411 1.01697 3.6364 0.906941L3.8501 0.900024H7.31677ZM16.2062 4.15002H14.9062V7.40002H16.2062V4.15002ZM13.6062 4.15002H10.5022L8.60502 6.14486C8.28298 6.48301 7.85199 6.69272 7.39175 6.73987L7.19296 6.75002L1.9001 6.74872V15.85C1.9001 16.8636 2.67345 17.6965 3.6623 17.7911L3.8501 17.8H14.9058L14.905 16.581C14.9018 16.5545 14.9001 16.5275 14.9001 16.5C14.9001 16.4729 14.9018 16.4461 14.905 16.4198L14.9043 15.2H14.2562C13.8971 15.2 13.6062 14.909 13.6062 14.55C13.6062 14.1911 13.8971 13.9 14.2562 13.9H14.9036L14.902 11.3H14.9001H14.2501C13.8912 11.3 13.6001 11.009 13.6001 10.65C13.6001 10.2911 13.8912 10 14.2501 10H14.9001L14.9006 8.70002H14.2562C14.0837 8.70002 13.9185 8.63154 13.7965 8.50964C13.6746 8.38775 13.6062 8.22242 13.6062 8.05002V4.15002ZM16.2046 15.85H16.8501C17.209 15.85 17.5001 16.1411 17.5001 16.5C17.5001 16.859 17.209 17.15 16.8501 17.15H16.2054L16.2058 17.8H18.1501C19.1637 17.8 19.9966 17.0267 20.0911 16.0379L20.1001 15.85V6.10002C20.1001 5.08641 19.3267 4.25344 18.3379 4.15896L18.1501 4.15002H17.5062V8.05002C17.5062 8.40901 17.2151 8.70002 16.8562 8.70002H16.2006L16.2024 11.95H16.8562C17.2151 11.95 17.5062 12.2411 17.5062 12.6C17.5062 12.959 17.2151 13.25 16.8562 13.25H16.2032L16.2039 14.4956C16.2054 14.5135 16.2062 14.5317 16.2062 14.55C16.2062 14.5681 16.2054 14.586 16.204 14.6037L16.2046 15.85ZM7.31677 2.20002H3.8501C2.83649 2.20002 2.00351 2.97338 1.90903 3.96223L1.9001 4.15002V5.44872L7.19296 5.45002C7.33527 5.45002 7.47261 5.40337 7.58466 5.31875L7.66365 5.2483L9.3023 3.52732L7.70677 2.33002C7.62239 2.26674 7.52431 2.22526 7.42121 2.20847L7.31677 2.20002Z"
                            fill="#128FEB"
                          />
                        </svg>
                      </div>
                      <div className="text">
                        {memoryData.docType === "PROJECT_TM_SNAPSHOT" ? (
                          <p>Relevant Company Translation Memory</p>
                        ) : memoryData.docType ===
                          "PROJECT_USER_GROUP_TM_SNAPSHOT" ? (
                          <p>Relevant Department Translation Memory</p>
                        ) : (
                          ""
                        )}

                        <span>
                          <DateFormat date={memoryData.createdDate} />
                        </span>
                        <span>{memoryData.sizeInKilobytes} kb</span>
                      </div>
                    </div>
                    <div className="right">
                      <button
                        className="download-file"
                        onClick={
                          memoryData.docType === "PROJECT_TM_SNAPSHOT"
                            ? () => downloadCompanyTm(memoryData.filename)
                            : () => downloadDepartmentTm(memoryData.filename)
                        }
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="18"
                          viewBox="0 0 16 18"
                          fill="none"
                        >
                          <path
                            d="M8.00087 17.6527L15.0742 10.5794C15.1834 10.4518 15.2405 10.2878 15.234 10.12C15.2275 9.9522 15.158 9.79304 15.0392 9.67431C14.9205 9.55558 14.7614 9.48602 14.5936 9.47954C14.4258 9.47306 14.2617 9.53013 14.1342 9.63935L8.66753 15.0993V1.33268C8.66753 1.15587 8.5973 0.986302 8.47227 0.861278C8.34725 0.736254 8.17768 0.666016 8.00087 0.666016C7.82406 0.666016 7.65449 0.736254 7.52946 0.861278C7.40444 0.986302 7.3342 1.15587 7.3342 1.33268V15.0993L1.8742 9.63935C1.81444 9.56956 1.74089 9.51288 1.65818 9.47287C1.57547 9.43285 1.48538 9.41036 1.39357 9.40682C1.30176 9.40327 1.2102 9.41874 1.12465 9.45226C1.0391 9.48577 0.961404 9.53661 0.896434 9.60158C0.831464 9.66655 0.780626 9.74425 0.747109 9.8298C0.713593 9.91535 0.698122 10.0069 0.701669 10.0987C0.705215 10.1905 0.727702 10.2806 0.767717 10.3633C0.807733 10.446 0.864413 10.5196 0.934201 10.5794L8.00087 17.6527Z"
                            fill="#1D4ED8"
                          />
                        </svg>
                        Download
                      </button>
                    </div>
                  </div>
                );
              })}
            </div>
          ) : null}

          <ConditionalBlock condition={uberTmList.length>0}>
          <div className="source-file">
             <div className="source-header flex-center">
              <h4>Custom TMs</h4>
            </div>
            {uberTmList.map((uberTm, index) => {return (
              <div className="source-file-item">
                <div className="left flex">
                  <div className="text">
                    {uberTm.uberTmEntity.name}
                  </div>
                </div>
                <div className="right">
                <button
                    className="download-file"
                    onClick={() => customTmDownload(uberTm.uberTmEntity?.name,uberTm.uberTmEntity)}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="18"
                      viewBox="0 0 16 18"
                      fill="none"
                    >
                      <path
                        d="M8.00087 17.6527L15.0742 10.5794C15.1834 10.4518 15.2405 10.2878 15.234 10.12C15.2275 9.9522 15.158 9.79304 15.0392 9.67431C14.9205 9.55558 14.7614 9.48602 14.5936 9.47954C14.4258 9.47306 14.2617 9.53013 14.1342 9.63935L8.66753 15.0993V1.33268C8.66753 1.15587 8.5973 0.986302 8.47227 0.861278C8.34725 0.736254 8.17768 0.666016 8.00087 0.666016C7.82406 0.666016 7.65449 0.736254 7.52946 0.861278C7.40444 0.986302 7.3342 1.15587 7.3342 1.33268V15.0993L1.8742 9.63935C1.81444 9.56956 1.74089 9.51288 1.65818 9.47287C1.57547 9.43285 1.48538 9.41036 1.39357 9.40682C1.30176 9.40327 1.2102 9.41874 1.12465 9.45226C1.0391 9.48577 0.961404 9.53661 0.896434 9.60158C0.831464 9.66655 0.780626 9.74425 0.747109 9.8298C0.713593 9.91535 0.698122 10.0069 0.701669 10.0987C0.705215 10.1905 0.727702 10.2806 0.767717 10.3633C0.807733 10.446 0.864413 10.5196 0.934201 10.5794L8.00087 17.6527Z"
                        fill="#1D4ED8"
                      />
                    </svg>
                    Download
                  </button>
                </div>
              </div>
            )})}             
          </div>
          </ConditionalBlock>
          
          <div className="source-file">
            <div className="source-header flex-center">
              <h4>Style Guide</h4>
            </div>
            {styleGuideData && styleGuideData?.length !== 0 ? (
              <div className="source-file-item styleguide1">
                <div className="left flex">
                  <div className="icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="22"
                      height="20"
                      viewBox="0 0 22 20"
                      fill="none"
                    >
                      <path
                        d="M7.31677 0.900024C7.66837 0.900024 8.01206 0.995054 8.31219 1.17323L8.48677 1.29002L10.5672 2.85002H18.1501C19.8015 2.85002 21.1651 4.08161 21.3727 5.67634L21.3932 5.88633L21.4001 6.10002V15.85C21.4001 17.5732 20.0591 18.983 18.3638 19.0931L18.1501 19.1H3.8501C2.12697 19.1 0.717046 17.7591 0.607014 16.0637L0.600098 15.85V4.15002C0.600098 2.4269 1.9411 1.01697 3.6364 0.906941L3.8501 0.900024H7.31677ZM16.2062 4.15002H14.9062V7.40002H16.2062V4.15002ZM13.6062 4.15002H10.5022L8.60502 6.14486C8.28298 6.48301 7.85199 6.69272 7.39175 6.73987L7.19296 6.75002L1.9001 6.74872V15.85C1.9001 16.8636 2.67345 17.6965 3.6623 17.7911L3.8501 17.8H14.9058L14.905 16.581C14.9018 16.5545 14.9001 16.5275 14.9001 16.5C14.9001 16.4729 14.9018 16.4461 14.905 16.4198L14.9043 15.2H14.2562C13.8971 15.2 13.6062 14.909 13.6062 14.55C13.6062 14.1911 13.8971 13.9 14.2562 13.9H14.9036L14.902 11.3H14.9001H14.2501C13.8912 11.3 13.6001 11.009 13.6001 10.65C13.6001 10.2911 13.8912 10 14.2501 10H14.9001L14.9006 8.70002H14.2562C14.0837 8.70002 13.9185 8.63154 13.7965 8.50964C13.6746 8.38775 13.6062 8.22242 13.6062 8.05002V4.15002ZM16.2046 15.85H16.8501C17.209 15.85 17.5001 16.1411 17.5001 16.5C17.5001 16.859 17.209 17.15 16.8501 17.15H16.2054L16.2058 17.8H18.1501C19.1637 17.8 19.9966 17.0267 20.0911 16.0379L20.1001 15.85V6.10002C20.1001 5.08641 19.3267 4.25344 18.3379 4.15896L18.1501 4.15002H17.5062V8.05002C17.5062 8.40901 17.2151 8.70002 16.8562 8.70002H16.2006L16.2024 11.95H16.8562C17.2151 11.95 17.5062 12.2411 17.5062 12.6C17.5062 12.959 17.2151 13.25 16.8562 13.25H16.2032L16.2039 14.4956C16.2054 14.5135 16.2062 14.5317 16.2062 14.55C16.2062 14.5681 16.2054 14.586 16.204 14.6037L16.2046 15.85ZM7.31677 2.20002H3.8501C2.83649 2.20002 2.00351 2.97338 1.90903 3.96223L1.9001 4.15002V5.44872L7.19296 5.45002C7.33527 5.45002 7.47261 5.40337 7.58466 5.31875L7.66365 5.2483L9.3023 3.52732L7.70677 2.33002C7.62239 2.26674 7.52431 2.22526 7.42121 2.20847L7.31677 2.20002Z"
                        fill="#128FEB"
                      />
                    </svg>
                  </div>
                  <div className="text">
                    <p>{styleGuideData.filename}</p>
                    <span>
                      <DateFormat date={styleGuideData.createdDate} />
                    </span>
                    <span>{styleGuideData.sizeInKilobytes} kb</span>
                  </div>
                  {styleGuideData.filename.toLowerCase().endsWith('.zip') && <StyleGuideToolTip />}
                </div>
                <div className="right">
                  <button
                    className="download-file"
                    onClick={() => downloadStyleGuide(styleGuideData.filename)}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="18"
                      viewBox="0 0 16 18"
                      fill="none"
                    >
                      <path
                        d="M8.00087 17.6527L15.0742 10.5794C15.1834 10.4518 15.2405 10.2878 15.234 10.12C15.2275 9.9522 15.158 9.79304 15.0392 9.67431C14.9205 9.55558 14.7614 9.48602 14.5936 9.47954C14.4258 9.47306 14.2617 9.53013 14.1342 9.63935L8.66753 15.0993V1.33268C8.66753 1.15587 8.5973 0.986302 8.47227 0.861278C8.34725 0.736254 8.17768 0.666016 8.00087 0.666016C7.82406 0.666016 7.65449 0.736254 7.52946 0.861278C7.40444 0.986302 7.3342 1.15587 7.3342 1.33268V15.0993L1.8742 9.63935C1.81444 9.56956 1.74089 9.51288 1.65818 9.47287C1.57547 9.43285 1.48538 9.41036 1.39357 9.40682C1.30176 9.40327 1.2102 9.41874 1.12465 9.45226C1.0391 9.48577 0.961404 9.53661 0.896434 9.60158C0.831464 9.66655 0.780626 9.74425 0.747109 9.8298C0.713593 9.91535 0.698122 10.0069 0.701669 10.0987C0.705215 10.1905 0.727702 10.2806 0.767717 10.3633C0.807733 10.446 0.864413 10.5196 0.934201 10.5794L8.00087 17.6527Z"
                        fill="#1D4ED8"
                      />
                    </svg>
                    Download
                  </button>
                </div>
              </div>
            ) : (
              <div className="source-file-item">
                <div className="left flex">
                  <div className="text">
                    Improve translation quality by uploading a style Guide
                  </div>
                </div>
                <div className="right">
                  <button
                    className="upload-file"
                    onClick={() => navigate("/reference")}
                  >
                    Style Guide
                  </button>
                </div>
              </div>
            )}
            {styleGuideUploadView ? (
              <div className="p-5">
                <UploadStyleGuide funct={getData} refId={styleGuideData.id} />
              </div>
            ) : null}
          </div>
        </>
      )}
    </div>
  );
}
